import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {
  constructor() {
  }

  private baseUrl = './';

  // BroadCast For Param dealer order Id value
  public PARAM_DEALER_ORDER = 'PARAM_DEALER_ORDER';
  // BroadCast For Data Change
  public DATA_CHANGE = 'DATA_CHANGE';
  // BroadCast For Data Change Added
  public DATA_CHANGE_ADDED = 'DATA_CHANGE_ADDED';
  // BroadCast For Param grower order Id value
  public PARAM_GROWER_ORDER = 'PARAM_GROWER_ORDER';
  // BroadCast For naigation to breadcrumb
  public NAVIGATE_TO_BREADCRUMB = 'NAVIGATE_TO_BREADCRUMB';
  // BroadCast For naigation to breadcrumb
  public BREADCRUMB_CLICK = 'BREADCRUMB_CLICK';
  // BroadCast For Account change
  public ACCOUNT_CHANGE = 'ACCOUNT_CHANGE';
  // BroadCast for Set Emulation and Clear Emulation
  public SET_CLEAR_EMULATION = 'SET_CLEAR_EMULATION';
  // BroadCast for COI Menu Hide Show
  public HIDE_SHOW_COI_MENU = 'HIDE_SHOW_COI_MENU';
  // BroadCast For DEILIVERY INSTRUCTION Change
  public DELIVERY_INSTRUCTION_CHANGE = 'DELIVERY_INSTRUCTION_CHANGE';
  // BroadCast For DEILIVERY INSTRUCTION ADD UPDATE DELETE Change
  public DELIVERY_INSTRUCTION_ADD_UPDATE_CHANGE = 'DELIVERY_INSTRUCTION_ADD_UPDATE_CHANGE';

  // Release items lots add update change
  public RELEASE_ITEMS_LOTS_ADD_UPDATE_CHANGE = 'RELEASE_ITEMS_LOTS_ADD_UPDATE_CHANGE';

  public SIGN_OUT = 'SIGN_OUT';

  // To select particualr tab
  public TAB_INDEX = 'TAB_INDEX';

  // To see the access type
  public ACCESS_TYPE = 'ACCESS_TYPE';

  public IS_AUTHORIZE = 'IS_AUTHORIZE';

  // BroadCast for Set Emulation UserId
  public SET_USER_EMULATION = 'SET_USER_EMULATION';

  public IN_EDIT = 'IN_EDIT';

  // BroadCast to check SRO_Access
  public SRO_ACCESS = 'SRO_ACCESS';

  public SRO_APROVERS_ACCESS = 'SRO_APROVERS_ACCESS';

  public EDLP_ACCESS = 'EDLP_ACCESS';

  // Header->

  // Year Dropdown
  private relCropYearUrl = 'api/Common/get-cropyear';
  // Company Dropdown
  private relCompanyCodeUrl = 'api/Common/get-companycode';

  private relCompanyNameUrl = 'api/Common/get-companyname';
  // update session info
  private relUpdateCurrentSessionUrl = 'api/UserSecurity/update-current-session';
  // Common->

  // Get Account List
  private relAccountListUrl = 'api/GrowerOrder/account-list';

  private relAccountInfoUrl = 'api/GrowerOrder/account-info';

  // Get Partner Website SSO URL
  private relPartnerWebsiteUrl = 'api/UserSecurity/partner-urls';

  // Get Partner Website SSO URL
  private relCropEdgeWebsiteUrl = 'api/UserSecurity/crop-edge-urls';

  // Dealer ->

  // Get dealer orders list
  private relDealerOrdersListUrl = 'api/DealerOrder/orders-list';

  private relDealerOrderValidateEaItemsUrl = 'api/DealerOrder/validate-ea-modification-items';

  private relDealerOrderGetEaMinExpUrl = 'api/DealerOrder/get-ea-minimum-unit-exception';

  private relDealerOrderModifyEaUnitsUrl = 'api/DealerOrder/modify-ea-modification-units';

  // Get dealer order items
  private relDealerOrderItemsUrl = 'api/DealerOrder/order-items';
  // Get dealer detail
  private relDealerDetailUrl = 'api/DealerOrder/dealer-detail';
  // Get dealer order detail
  private relDealerOrderDetailUrl = 'api/DealerOrder/dealer-order-detail';
  // Get item growers detail
  private relItemGrowersDetailUrl = 'api/DealerOrder/item-growers-detail';
  // Add dealer order
  private relDealerOrderAddUrl = 'api/DealerOrder/order-add-edit';
  // update dealer order
  private relDealerOrderUpdateUrl = 'api/DealerOrder/order-add-edit';
  // Get the item for modify
  private relGetModifyItemUrl = 'api/DealerOrder/modify-item';
  // Calculate ea units for modify item
  private relCalculateEAUnitsModifyItemUrl = 'api/DealerOrder/calculate-eaunits-modify-product';

  private checkUser4InternalTransferUrl = 'api/DealerOrderTransferInternal/internal-transfer-allowed';
  private deleerToAccountListUrl = 'api/DealerOrderTransferInternal/to-account-list';

  // Get the allocation availability
  private relAllocationAvailabilityUrl = 'api/OrderTransfer/allocation-availability';

  // Get the internal allocation availability
  private relInternalAllocationAvailabilityUrl = 'api/DealerOrderTransferInternal/allocation-availability';
  // Get dealer order to items for ea swap
  private relDealerOrderToItemUrl = 'api/DealerOrder/ea-swap-dealer-order-to-items';
  // Update ea swap order
  private relEaSwapUpdateOrderUrl = 'api/DealerOrder/ea-swap-update-order';
  // Update ea swap order
  private relEaSwapModifiableUnitsUrl = 'api/DealerOrder/ea-swap-modifiable-units';
  // Get EA items
  private relDealerOrderEaItemsUrl = 'api/DealerOrder/ea-order-items';
  // Update EA Add Product to order
  private relEaAddUpdateOrderUrl = 'api/DealerOrder/ea-add-update-order';

  // OAuth

  getAuthToken(code, urlRef): string {
    return this.baseUrl + 'api/Authentication/authenticate?code=' + code + '&urlRef=' + urlRef;
  }

  getAuthTokenByRefreshToken(refreshToken): string {
    return this.baseUrl + 'api/Authentication/reauthenticate?refreshToken=' + refreshToken;
  }

  getOAuthSettings(urlRef): string {
    return this.baseUrl + 'api/Authentication/get-oauth-settings?urlRef=' + urlRef;
  }

  // Grower ->
  // Get Grower List
  private relGrowerListUrl = 'api/GrowerOrder/grower-list';
  // Get Grower detail
  private relGrowerDetailUrl = 'api/GrowerOrder/get-grower-detail';
  // Get Grower Product change
  private relGrowerProductChangeUrl = 'api/GrowerOrder/product-change-item';
  // Add or update grower order
  private relGrowerOrderAddUpdateUrl = 'api/GrowerOrder/add-edit-product-booking';

  // Validate Account For B2BEnablement
  private relValidateAccountForB2BEnablement = 'api/GrowerOrder/validate-account-b2b-enablement';
  // Get Grower order items
  private relGrowerOrderItemsUrl = 'api/GrowerOrder/grower-order-items';

  // Check hybrid button access
  private relCheckHyrbridAddAccessUrl = 'api/GrowerOrder/check-hybrid-btn-access';

  private relGetHybridVarietyPackageSizeListGrwerUrl = 'api/GrowerOrder/get-hybrid-variety-package-sizes';
  // Get Seller List
  private relGetSellerListUrl = 'api/common/get-seller-list';
  // Get Product Availability
  private relProductAvailabilityUrl = 'api/GrowerOrder/product-availability';
  // Get Grower order list
  private relGrowerListByAccountUrl = 'api/GrowerOrder/get-order-list';

  private relGrowerSearchUrl = 'api/GrowerOrder/grower-list-by-account';

  // Add new grower
  private relAddNewGrowerUrl = 'api/Grower/add-grower';

  // Add new grower
  private relNewGrowerAddToSystemUrl = 'api/Grower/add-grower-to-system';
  //Add new seller
  private relrequestNewGrowerUrl = 'api/Grower/request-new-grower';
  private relMapOrFetchGmkUrl = 'api/Grower/map-fetch-gmk';
  // MasterData->
  // Get Item Number List
  private relItemNoMasterUrl = 'api/Common/get-itemNumber-master';
  // Get Grower PDF Data
  private getGrowerPdfDataUrl = 'api/GrowerOrder/get-grower-pdf-data';
  // Get All master data list
  private relMasterDataUrl = 'api/Common/get-master-data';

  // Get HybridVarietyMaster
  private relHybridVarietyMasterUrl = 'api/Common/get-hybridVariety-master';

  // Get All master data list
  private relFilterDataUrl = 'api/Common/get-filter-data';

  // Get All master data list for Prepay
  private relFilterDataPrepayUrl = 'api/Prepay/get-filter-data-prepay';

  // Get All master data list
  private relGrowerSearchDataUrl = 'api/GrowerOrder/grower-search-ddl';

  // Get All master data list
  private relGrowerSearchApiUrl = 'api/Grower/grower-search';

  //Get Message Configuration
  private relgetMessageConfigurationApiUrl = 'api/Common/get-message-configuration';

  // Order transfer ->
  // Save Grower to Grower transfer
  private relG2FTansferUrl = 'api/OrderTransfer/transfer-grower-order';

  // Order transfer ->
  // Save Grower to Grower transfer from one Dealer to another
  private relG1D1G2D2FTansferUrl = 'api/OrderTransfer/transfer-grower-dealer-order';

  // Dealer order transfer ->
  // Save dealer order transfer
  private relD2DTansferUrl = 'api/OrderTransfer/transfer-dealer-order';

  private relD2DInternalTansferUrl = 'api/DealerOrderTransferInternal/transfer-dealer-order-internal';
  private relD2DValidateInternalTansferUrl = 'api/DealerOrderTransferInternal/validate-internal-dealer-transfer';
  // Dealer order transfer ->
  private relValidateTransferDealerOrderUrl = 'api/OrderTransfer/validate-transfer-dealer-order';
  // Get EA status for dealer order
  private relGetDealerEAStatusUrl = 'api/DealerOrder/dealer-ea-status';

  // Get dealer account list
  private relDealerAccountListUrl = 'api/DealerOrder/dealer-account-list';

  // User Security - Account tab
  private relAccountListingUrl = 'api/UserSecurity/account-data';

  // User Security - Account tab
  private relCropEdgeAccountListUrl = 'api/UserSecurity/get-crop-edge-account';
  // User Security - Validate
  private relValidateEvolveUrl = 'api/UserSecurity/validate-evolve';
  // User Security - Validate
  private relSaveAddToAccountUrl = 'api/UserSecurity/save-add-to-account';
  private relRemoveUserSelectedAccountUrl = 'api/UserSecurity/remove-user-select-account';
  // User Security - chat acceess
  private relGetChatAccessUrl = 'api/UserSecurity/chat-access';
  private relgetGetLoginAccountIdUrl = 'api/UserSecurity/get-login-account-dl';
  private checkSraAccountAccess = 'api/UserSecurity/check-account-sra-access';
  private checkEdlpAccess = 'api/UserSecurity/check-edlp-access';
  private checkSraApproversAccess = 'api/UserSecurity/check-sra-approvers-access';
  // Seed Fulfillment->

  // Get unsbmitted draft list
  private unsubmittedDraft = 'api/SeedFulfillment/unsubmitted-list';
  // Get unsbmitted draft list
  private submittedRequest = 'api/SeedFulfillment/submitted-list';
  // Get ShipToAccounts for Fulfillment
  private getReleaseFilterData = 'api/SeedFulfillment/get-filter-data';
  // Get release order items
  private releaseOrderItems = 'api/SeedFulfillment/get-release-order-items';
  // Get modify release order items
  private modifyReleaseOrderItems = 'api/SeedFulfillment/get-modify-release-order-items';
  // Get seed fulfillment item availability by lot url
  private seedFulfillmentitemAvailabilityByLot = 'api/SeedFulfillment/get-items-availability-by-lots';
  // Add Release items lot
  private addReleaseItemsLot = 'api/SeedFulfillment/add-release-items-lot';
  // Get pallet and seed weight
  private getPalletAndSeedWeight = 'api/SeedFulfillment/get-pallet-and-seed-weight';
  // Get Request Date
  private getrequestdate = 'api/SeedFulfillment/get-request-date';
  // Add Update Release Order
  private addUpdateReleaseOrder = 'api/SeedFulfillment/add-update-release-order';
  // Delete Release Order
  private releaseOrderDelete = 'api/SeedFulfillment/delete-release-order';
  // Place multiple JDE Order
  private placeMultipleJDEOrder = 'api/SeedFulfillment/place-multiple-jde-order';
  // Get Release data
  private releaseDataUrl = 'api/SeedFulfillment/get-release-data';
  // Get Request Type data
  private requestTypeUrl = 'api/SeedFulfillment/get-request-type';
  // Get Delivery Instructions
  private deliveryInstructions = 'api/DeliveryInstructions/get-delivery-instructions';
  // Get filtered unsubmitted release order
  private filteredUnSubmittedReleaseOrder = 'api/SeedFulfillment/filtered-un-submitted-release-order';
  // Place Single JdeOrder url
  private placeSingleJDEOrder = 'api/SeedFulfillment/place-single-jde-order';

  private unSubmittedReportUrl = 'api/SeedFulfillment/unSubmitted-release-report';

  private submittedReportUrl = 'api/SeedFulfillment/submitted-release-report';

  private canItemListForCboxUrl = 'api/SeedFulfillment/can-cbox-item-list';

  // Sign Out url
  private signOut = 'api/Authentication/sign-out';
  // Get filtered submitted release order
  private filteredSubmittedReleaseOrder = 'api/SeedFulfillment/filtered-submitted-release-order';

  // Get products
  private getProducts = 'api/LineItemAvailability/get-products';

  // Get product availability
  private getProductsAvailabilityReport = 'api/LineItemAvailability/get-products-availability';

  // Get Product Availability Email Report
  private getProductsAvailabilityEmailReport = 'api/LineItemAvailability/get-availability-report-email';

  // Get report account list
  private getReportAccountList = 'api/LineItemAvailability/get-accounts';

  // Quick Report
  // Get filter data for report
  private getReportFilterDataUrl = 'api/Common/get-report-filter-data';

  // Get filter data for report
  private getQuickSearchFilterDataUrl = 'api/QuickSearchOrder/get-quick-search-order';

  // Get filter data for report
  private getSubstitutionOrderReportDataUrl = 'api/SubstitutionOrderReport/get-substitution-order-report';

  // Grower Audit
  // Get Account
  private getGARAccountUrl = 'api/GrowerDealerAudit/get-gar-accounts';
  // Dealer Audit
  // Get Account
  private getDARAccountUrl = 'api/GrowerDealerAudit/get-dar-accounts';

  // Get Dealer Order Audit Log
  private getDealerOrderAuditLog = 'api/GrowerDealerAudit/get-dealer-order-audit-log';

  // Get Dealer Order Audit Log
  private getGrowerOrderAuditLog = 'api/GrowerDealerAudit/get-grower-order-audit-log';

  // Get Show Hybrid Variety Package Size
  private getShowHybridVarietyPackageSize = 'api/GrowerDealerAudit/show-hybrid-variety-package-size';

  // Emulation
  // Get district data filter url
  private getDistrictDataFilterUrl = 'api/Emulation/get-district-filter-data';

  // Emulation
  // Get filter data for emulation
  private getAttachedAccountDataUrl = 'api/Emulation/get-attached-account-data';

  // Emulation
  // Get user ids for emulation
  private getUserIdsDataUrl = 'api/Emulation/get-user-ids';

  // Set Emulation
  private setEmulation = 'api/Emulation/set-emulation';

  // Clear Emulation
  private clearEmulation = 'api/Emulation/clear-emulation';

  // Total Order Summary
  private getTotalOrderSummaryUrl = 'api/OrderSummary/get-total-order-summary';

  //Get User Report Filters
  private getUserReportFiltersUrl = 'api/UserReportFilter/get-user-report-filters';

  //Update User Report Filters
  private updateUserReportFiltersUrl = 'api/UserReportFilter/update-user-report-filter';

  //Delete User Report Filters
  private deleteUserReportFiltersUrl = 'api/UserReportFilter/delete-user-report-filter';

  //Delete User Report Filters
  private addUserReportFiltersUrl = 'api/UserReportFilter/add-user-report-filter';

  // PrePay
  // Get Active Pending Contracts
  private getActivePendingClosedContractsUrl = 'api/PrePay/get-active-pending-closed-contracts';
  // Get ContractDetail
  private getContractDetailUrl = 'api/PrePay/get-contract-detail';
  // Get ContractDetail
  private getSeedPrePayContractsUrl = 'api/PrePay/get-seed-prepay-contracts';
  // Cancel request url
  private getCancelContractRequestUrl = 'api/PrePay/cancel-contract-request';
  // Add Update request url
  private getAddUpdateContractRequestUrl = 'api/PrePay/add-update-contract-request';
  // Get prepay detail url
  private getPrepayDetailUrl = 'api/PrePay/get-prepay-detail';
  // Get Crop year data
  private getCropYearDetailDataUrl = 'api/PrePay/get-cropyear-data';
  private getTermsAndConditionByRefrenceNameUrl = 'api/PrePay/get-Media-Object-by-name';

  // Get shippable products url
  private getShippableProductsUrl = 'api/ShippableProducts/get-shippable-products';

  // Get Release Items Audit Log
  private getReleaseItemsAuditLog = 'api/ReleaseItemsAudit/get-release-items-audit-log';

  // Get Cpp Item Number data
  private getCppItemNumberDataUrl = 'api/CPPOrder/get-item-numbers';

  // Get Cpp Parent Item Number data
  private getCppParentItemNumberDataUrl = 'api/CPPOrder/get-cpp-item-numbers';

  // Get Cpp Disclaimer Message
  private getDisclaimerMessageDataUrl = 'api/CPPOrder/get-disclaimer-message';

  // Get Cpp Item Number data with IsCPP in ('N','Y')
  private getCppItemNumberDataWithCPP_N_Url = 'api/CPPOrder/get-all-item-numbers';

  // Get All Cpp Item data for Add Product Slider
  private getAllCppItemListDataUrl = 'api/CPPOrder/get-item-list';

  // Delete item from CPP cart
  private deleteFromCartDataUrl = 'api/CPPOrder/delete-cart-item';

  // Get Cpp item master details for Add Product Slider

  private getCppItemMasterDetailsDataUrl = 'api/CPPOrder/get-cpp-item-master-details';

  // Get Cpp orders list
  private getCppOrderItemsUrl = 'api/CPPOrder/get-cpp-orders';

  // Get Cpp Error orders list
  private getCppErrorOrdersUrl = 'api/CPPOrder/get-cpp-error-orders';

  // Get Cpp Ship To Account data
  private getCppShipToFacilityDataUrl = 'api/CPPOrder/get-ship-to-facility';
  // Get Cpp Delivery To Account data
  private getCppDeliverToFacilityDataUrl = 'api/CPPOrder/get-deliver-to-facility';
  // Get Cpp Sold To Account data
  private getCppSoldToFacilityDataUrl = 'api/CPPOrder/get-sold-to-facility';
  // Get Sro Sold To Account data
  private getSroSoldToFacilityDataUrl = 'api/CPPSROOrder/get-sold-to-facility';
  private getSroDisclaimerMessageDataUrl = 'api/CPPSROOrder/get-disclaimer-message';
  // Get Cpp Existing Order Detail
  private getCppShipToOrderDetailUrl = 'api/CPPOrder/get-cpp-order-detail';
  private getSroShipToOrderDetailUrl = 'api/CPPSROOrder/get-sro-order-detail';
  private getSroExistingOrderUrl = 'api/CPPSROOrder/get-existing-orders';
  private getSroEditOrderDetailDataUrl = 'api/CPPSROOrder/get-sro-edit-order-data';

  // Get single Cpp order details
  private getCppOrderDetailDataUrl = 'api/CPPOrder/get-cpp-order-data';

  // Get Cpp edit order details
  private getCppEditOrderDetailDataUrl = 'api/CPPOrder/get-cpp-edit-order-data';

  // Check for existing Draft Order
  private checkExistingDraftOrderUrl = 'api/CPPOrder/check-existing-draft-order';

  // Save order data
  private saveOrderdataUrl = 'api/CPPOrder/save-order';

  // Place order data
  private placeOrderdataUrl = 'api/CPPOrder/place-order';

  // Resubmit order data
  private resubmitOrderdataUrl = 'api/CPPOrder/resubmit-order';

  // Resubmit orders list data
  private resubmitOrdersListdataUrl = 'api/CPPOrder/resubmit-orders-list';

  // Delete order Items
  private deleteOrderItemsUrl = 'api/CPPOrder/delete-order-items';

  // Get CPP instruction type list.
  private getCPPInstructionTypeDataUrl = 'api/CPPOrder/get-cpp-instruction-type-data';
  // Set favorite
  private setFavoriteUrl = 'api/CPPOrder/set-favorite';
  //set Facvorite for CPPPricelist
  private setPriceListFavoriteUrl = 'api/CPPPriceList/save-favorite-item';
  // Delete order url
  private deleteCppOrderUrl = 'api/CPPOrder/delete-cpp-order';
  // Get Order Summary details.
  private getOrderSummaryDetailsUrl = 'api/CPPOrder/get-cpp-order-summary-detail';
  // Post confirmation email
  private getCPPOrderConfirmationEmailUrl = 'api/CPPOrder/send-cpp-order-confirmation-email';
  // get CPP excel report
  private getCPPReportUrl = 'api/CPPOrder/get-cpp-report';
  private checkSurveyMessageEligibiltyDataUrl = 'api/SeedReturn/survey-message-eligibility';
  private saveSurveyPreferenceDataUrl = 'api/SeedReturn/save-survey-preference';
  private checkOTISurveyMessageEligibiltyDataUrl = 'api/OTI/survey-message-eligibility';
  // CPP Price

  // Get All Price Filter data list
  private cppPriceListFilterDataUrl = 'api/CPPPriceList/get-filter-master-data';
  // get CPP price data url
  private getCPPProductDataUrl = 'api/CPPPriceList/get-cpp-product';
  // get export url for cpp price
  private getCPPPriceExportDataUrl = 'api/CPPPriceList/export-report';
  private saveItemFavoriteUrl = 'api/CPPPriceList/save-favorite-item'
  // get CPP price account url
  private getPriceListAccountUrl = 'api/CPPPriceList/get-price-list-account';

  private emailCPPProductListUrl = 'api/CPPPriceList/email-product-list';

  private setCostFavoriteUrl = 'api/CPPPriceList/save-favorite-item';
  // cpp delivery instructions

  private cppGetDeliveryInstructionListUrl = 'api/CPPDeliveryInstruction/delivery-instructions-list';
  private cppGetUserListUrl = 'api/CPPUserList/cpp-landing-user-list';

  // cpp product Label

  // get Product Label Account List
  private productLabelAccountListUrl = 'api/CPPProductLabel/get-product-label-account';

  //get Product Label Items List
  private productLabelItemsListUrl = 'api/CPPProductLabel/get-product-label-items';

  // cpp Save Product Label Order
  private saveProductLabelOrderUrl = 'api/CPPProductLabel/save-product-label-order';

  // cpp Get Product Label Orders
  private getProductLabelOrdersUrl = 'api/CPPProductLabel/get-product-label-orders';

  // cpp Get Product Label Orders Details
  private getProductLabelOrderDetailsUrl = 'api/CPPProductLabel/get-product-label-order-details';

  // cpp Get Unauthorized Product Warning Message
  private unauthorizedProductWarningMsgUrl = 'api/CPPProductLabel/get-unauthorized-product-warning-message';

  // getSulfurZincPricingReportsData
  private getSulfurZincPricingReportUrl = 'api/CPPReports/get-sulfur-zinc-pricing-report-data';

  // getAMSPricingReportData
  private getAMSPricingReportUrl = 'api/CPPReports/get-ams-pricing-report-data';

  // EDLP API URLs
  private edlpConfigUrl = 'api/EDLP/get-config';
  private edlpEligibleAccountsUrl = 'api/EDLP/get-eligible-accounts';
  private edlpPricingDataUrl = 'api/EDLP/get-pricing-data';
  private edlpLastRefreshDateUrl = 'api/EDLP/get-last-refresh-date';
  private edlpInitialDataUrl = 'api/EDLP/get-initial-data';
  private edlpExportExcelUrl = 'api/EDLP/export-excel';
  private edlpSubscriptionStatusUrl = 'api/EDLP/get-subscription-status';
  private edlpUpdateSubscriptionUrl = 'api/EDLP/update-subscription';

  // get OwnerPriceListAccessPermission Url
  private OwnerPriceListAccessPermissionUrl = 'api/CPPPriceList/get-owner-pricelist-access-permission-data';

  // get CPP customer price data url
  private getCPPCustomerPriceDataUrl = 'api/CPPPriceList/get-cpp-customer-price';

  // CPP Manage Subscription
  private getManageSubscriptionUrl = 'api/CPPPLManageSubscription/get-manage-subscription-list';

  // Login User Status
  private getSubscriptionStatusUrl = 'api/CPPPLManageSubscription/get-loginuser-Status';

  // Update Status
  private getUpdateStatusUrl = 'api/CPPPLManageSubscription/update-Status';

  // Add Update Subscription Status
  private getAddUpdateSubscriptionUrl = 'api/CPPPLManageSubscription/add-update-subscription';
  // Add Valid For Subscription
  private isValidForSubscriptionUrl = 'api/CPPPLManageSubscription/valid-for-subscription';

  private getPricingReportManageSubscriptionUrl = 'api/CPPPRManageSubscription/get-manage-subscription-list';
  private getAddUpdatePricingReportSubscriptionUrl = 'api/CPPPRManageSubscription/add-update-subscription';

  // Licensing
  // Get licensing list
  private getLicenseListUrl = 'api/License/get-license-data';
  // Get Licensing Filters
  private getLicenseFiltersUrl = 'api/License/get-license-filter-data';
  // get AddUpdateGrowerLicenseUr
  private getAddUpdateDeleteGrowerLicenseUrl = 'api/License/add-update-delete-grower-license';
  // Get licensing list
  private getLicenseReportUrl = 'api/License/get-report';
  // Get licensing list
  private getLicenseOrderDetailUrl = 'api/License/get-order-detail';
  // Get grower gln
  private getGrowerGLNUrl = 'api/License/get-grower-gln';

  // Seed Return
  // Get Account List return request
  private seedReturnAccountListUrl = 'api/SeedReturn/account-list';

  // Get Fright Instructions list
  private seedReturnFreightInstUrl = 'api/SeedReturn/get-freight-instruction';

  // Get Banner Message
  private bannerMessageUrl = 'api/SeedReturn/get-banner-message';

  // Check OTI Orders
  private checkOTIOrdersUrl = 'api/SeedReturn/check-oti-orders';

  // Get Seed Return Item Number data
  private getSeedReturnItemNumberDataUrl = 'api/SeedReturn/get-item-numbers';

  // Get Cpp orders list
  private getReturnRequestUrl = 'api/SeedReturn/get-return-request';

  // Get Cpp orders list
  private getReturnRequestExportUrl = 'api/SeedReturn/get-return-request-export';

  // Get seed return  edit order details
  private getReturnRequestEditDetailDataUrl = 'api/SeedReturn/get-edit-request-data';

  // Get DSM data
  private getDsMInfoUrl = 'api/SeedReturn/get-dsm';
  // Get invoice number list
  private getInvoiceNumberListUrl = 'api/SeedReturn/get-invoice-number';
  // Get all invoiced products for grid
  private getInvoicedProductItemsUrl = 'api/SeedReturn/get-items-list';
  // /get all lot master
  private getLotMasterItemsUrl = 'api/SeedReturn/get-lot-master-list';
  // /save return request
  private saveReturnRequestItemsUrl = 'api/SeedReturn/save-return-request';
  // /save scale tickets request
  private saveReturnScaleTicketUrl = 'api/SeedReturn/save-scale-tickets';
  // /submit to jde return request
  private submitToJDEReturnRequestItemsUrl = 'api/SeedReturn/submit-request-jde';
  // /get scale ticket file
  private getScaleTicketFileUrl = 'api/SeedReturn/download-file';

  // /delete scale ticket
  private deleteScaleTicketUrl = 'api/SeedReturn/delete-file';

  private deleteReturnRequestUrl = 'api/SeedReturn/delete-return-request';
  private accountUserRequestUrl = 'api/SeedReturn/get-account-user-list';
  private scaleTicketFileExtensionsUrl = 'api/SeedReturn/get-scale-ticket-file-extensions';

  // Get Process Access for non soybean
  private getProcessAccessForNonSoybeanUrl = "api/SeedReturn/get-process-access";

  // Get Return Period Validation Status for selected Ship-To account
  private getReturnPeriodValidationUrl = "api/SeedReturn/get-return-period-validation";

  // Get seed return Delivery To Account data
  public getSeedReturnDeliverToFacilityDataUrl = `${this.baseUrl}api/SeedReturn/get-deliver-to-facility/Account/{{accountNumber}}/ParentAccount/{{shipToAccountParentNumber}}`;

  // Get return request header id by inputs value for draft
  public getDraftReturnRequestDataUrl = `${this.baseUrl}api/SeedReturn/get-draft-return-request/Account/{{accountNumber}}/ProductLine/{{productLineCode}}`;

  // Get seed return, return master data
  public getSeedReturnReturnMasterDataUrl = `${this.baseUrl}api/SeedReturn/get-return-master/ProductLine/{{productLine}}`;

  // Get seed return, return period security data
  public getReturnPeriodSecurityDataUrl = `${this.baseUrl}api/SeedReturn/get-return-security-access`;

  // Get seed return, return period security data
  public getAccountdetails = `${this.baseUrl}api/SeedReturn/get-account-details`;

  // Save Records for Soybean Zero Dump
  private saveSoybeanNoDumpsUrl = `api/SeedReturn/save-zero-dumps`;

  // Get Miscellaneous Item Computation data for given product Line
  public GetMiscellaneousItemComputationDataUrl = `${this.baseUrl}api/SeedReturn/get-miscellaneous-count`;

  // Get Cpp orders list
  private getProductLineUrl = 'api/SeedReturn/get-product-line';

  private getWarningMessageUrl = 'api/SeedReturn/get-warning-message';

  private getCPPReturnsInoculantWarningMessageUrl = 'api/CPPReturns/get-inoculant-warning-message';

  private getCPPReturnsInoculantErrorMessageUrl = 'api/CPPReturns/get-inoculant-error-message';
  private getInoculantRestrictionUrl = 'api/CPPReturns/check-date-InoculantRestriction';
  private getCPPReturnInoculantReportDistributionEmailUrl = 'api/CPPReturns/get-report-distribution-email';

  //Update Return Request Status
  public updateReturnRequestStatus = `${this.baseUrl}api/SeedReturn/update-soybean-return-request`;

  // OTI
  // Get oti dashboard filter data
  private getOtiFilterUrl = 'api/OTI/get-dashboard-filter-data';
  // Get oti order dashboard filter data
  private getOtiOrderFilterUrl = 'api/OTI/get-oti-order-filter';
  // Get oti order
  private getOtiOrdreUrl = 'api/OTI/get-order-to-invoice-order';
  // Get oti order landing
  private getOtiOrderListUrl = 'api/OTI/get-oti-order-cpp-list';
  // Get oti Seed order landing
  private getOtiSeedOrderListUrl = 'api/OTI/get-oti-order-seed-list';
  // Get oti Export List
  private getOtiExportUrl = 'api/OTI/get-order-to-invoice-export-list';

  //OIP

  // Get oip Filter Master Data
  private getFilterMasterDataOipUrl = 'api/OTI/get-filter-master-data-oip';

  // Get oip Data 
  private getDataOipUrl = 'api/OTI/get-data-oip';
  // Get Seed Search List
  private getSeedSearchListUrl = 'api/OTI/get-seed-search-data';
  //
  // Get OTI Order Summary data
  private getOTISummaryDataUrl = 'api/OTI/get-oti-summary-data';
  // Get oti user profile
  private getOtiUserProfileUrl = 'api/OTI/get-oti-user-profile';
  // SET oti default product segment
  private setOtiProductSegment = 'api/OTI/set-default-product-segment';
  // Get oti user profile
  private getOtiHistoryDaysUrl = 'api/OTI/get-config-order-history-days';

  // Get data for quote order details
  private getQuoteOrderDetailUrl = 'api/BasketPricing/get-quote-order-details';

  // Approve Or Reject Quote
  private approveOrRejectQuoteUrl = 'api/BasketPricing/approve-reject-quote';

  // Close Quote
  private closeQuoteUrl = 'api/BasketPricing/close-quote-order';

  // submit sales order Quote
  private submitSalesOrderUrl = 'api/BasketPricing/submit-sales-order';

  // Get data for quote order product
  private getQuoteOrderProductUrl = 'api/BasketPricing/get-quote-order-product';

  // check quore order access
  private getQuoteOrderAccessUrl = 'api/BasketPricing/check-quote-order-access';

  // Save order data
  private saveQuoteOrderdataUrl = 'api/BasketPricing/save-order';

  // Check for existing Draft Order
  private checkQuoteExistingDraftOrderUrl = 'api/BasketPricing/check-existing-draft-order';

  // Get Quote orders list
  private getQuoteOrderItemsUrl = 'api/BasketPricing/get-quote-orders-items';

  // Get Quote orders list Export
  private getQuoteOrderItemsExportUrl = 'api/BasketPricing/get-quote-orders-items-export';

  // Get Quote Orders
  private getQuoteOrderUrl = 'api/BasketPricing/get-quote-orders';

  // Get data for quote order details
  private getQuoteOrderSummaryUrl = 'api/BasketPricing/get-quote-order-summary';

  // get pdf url
  private getTestPDFUrl = 'api/CPPOrder/getTestPDF';

  // Post confirmation email
  private getQuoteOrderConfirmationEmailUrl = 'api/BasketPricing/send-quote-order-confirmation-email';

  // Get account SDM data
  private getAccountSDMReasonCodeDataUrl = 'api/CppOrder/accountsdm-reasoncode-data';

  // Get items SDM data
  private getItemsSDMDataUrl = 'api/CppOrder/item-master-sdm-data';

  // post base64 pdf format
  private getBasePdfUrl = 'api/CPPOrder/FileShareMobilePDFURL';

  // post base64 pdf format
  private getBasePdfSotUrl = 'api/SOTStockTransfer/FileShareMobilePDFURL';

  // post base64 pdf format
  private getSeedBasePdfUrl = 'api/CPPOrder/FileShareMobilePDFURL';
  // post base64 pdf format
  private getSeedPdfUrl = 'api/GrowerOrder/FileShareMobilePDFURL';
  // get pdfurl from base64
  private getTestPdfUrlfromBase = 'api/CPPOrder/MobilePDFURL';

  // check blanket order access
  private getBlanketOrderAccessUrl = 'api/BlanketOrder/check-blanket-order-access';

  // Get blanket orders list
  private getBlanketOrderItemsUrl = 'api/BlanketOrder/get-blanket-orders-items';

  // Get blanket orders Export list
  private getBlanketOrderExportItemsUrl = 'api/BlanketOrder/get-blanket-orders-export';

  // Get blanket orders list
  private getBlanketShipToListUrl = 'api/BlanketOrder/get-blanket-ship-to';

  // Get All Blanket Item data for Add Product Slider
  private getAllBlanketItemListDataUrl = 'api/BlanketOrder/get-item-list';

  // Get EA Order details
  private getEAOrderSummaryUrl = 'api/BlanketOrder/get-blanket-order-summary-detail';

  // Get EA Order details
  private getEABlanketEditUrl = 'api/BlanketOrder/get-blanket-edit-order';

  // Get Exisitng Draft Order
  private getDraftOrderUrl = 'api/BlanketOrder/check-existing-draft-order';

  private uploadProductExcelUrl = 'api/BlanketOrder/import-excel';

  private downloadProductExcelUrl = 'api/BlanketOrder/download-eaOrder-template';
  // EA Place order data
  private placeBlanketOrderdataUrl = 'api/BlanketOrder/place-order';

  // EA Place order data
  private saveBlanketOrderdataUrl = 'api/BlanketOrder/save-draft-order';

  // Get Command Center Cpp Data Url
  private getCommandCenterCppDataUrl = 'api/CommandCenter/get-command-center-cpp-list';

  // Get Command Center Seed Data Url
  private getCommandCenterSeedCppDataUrl = 'api/CommandCenter/get-command-center-seed-list'

  // Get Message for Message Center  Data Url
  private getMessageCenterDataUrl = 'api/CommandCenter/get-messages-message-center';

  // Pin UnPin Message Data Url
  private pinUnPinMessageDataUrl = 'api/CommandCenter/pin-unpin-message';

  // Read Message Data Url
  private readMessageDataUrl = 'api/CommandCenter/read-message';

  // Get knowledge center  Data Url
  private getknowledgeCenterDataUrl = 'api/CommandCenter/get-knowledge-center';

  // ### CPP Returns ###
  // Get account SDM data
  public CPPReturnsAccountSDMDataUrl = `${this.baseUrl}api/CPPReturns/AccountSDMData`;

  // Get ProductLineList
  public CPPProductLineListUrl = `${this.baseUrl}api/CPPReturns/product-line-list`;

  // Get Account List return request
  public cppReturnsAccountListUrl = `${this.baseUrl}api/CPPReturns/account-list`;

  // Get Banner Message
  public cppReturnsBannerMessageUrl = `${this.baseUrl}api/CPPReturns/get-banner-message`;

  // Check OTI Orders
  public cppReturnsCheckOTIOrdersUrl = `${this.baseUrl}api/CPPReturns/check-oti-orders`;

  // Get Seed Return Item Number data
  public getCppReturnsItemNumberDataUrl = `${this.baseUrl}api/CPPReturns/get-item-numbers`;

  // Get Cpp orders list
  public getCppReturnsRequestUrl = `${this.baseUrl}api/CPPReturns/get-return-request`;

  // Get Cpp orders list
  public getCppReturnsRequesReporttUrl = `${this.baseUrl}api/CPPReturns/get-return-request-report`;

  // Get Access For Return/Draft Tab
  public getAccessRequestCPP = `${this.baseUrl}api/CPPReturns/check-new-return-access`;

  // Get seed return  edit order details
  public getCppReturnsRequestEditDetailDataUrl = `${this.baseUrl}api/CPPReturns/get-edit-request-data`;

  // Get DSM data
  public getCppReturnsDsmInfoUrl = `${this.baseUrl}api/CPPReturns/get-dsm`;

  // Get invoice number list
  public getCppReturnsInvoiceNumberListUrl = `${this.baseUrl}api/CPPReturns/get-invoice-number`;

  // Get all invoiced products for grid
  public getCppReturnsInvoicedProductItemsUrl = `${this.baseUrl}api/CPPReturns/get-items-list`;

  // /get items for manual tab
  public getCppReturnsItemsForManualProductsUrl = `${this.baseUrl}api/CPPReturns/get-products`;

  // get products for manual tab
  public getCppReturnsForManualProductsUrl = `${this.baseUrl}api/CPPReturns/get-manual-items-list`;

  // get item uom for manual tab
  public getCppReturnsForItemUOMUrl = `${this.baseUrl}api/CPPReturns/get-item-uom`;

  // /save return request
  public saveCppReturnsRequestItemsUrl = `${this.baseUrl}api/CPPReturns/save-return-request`;

  // /submit to jde return request
  public submitToJDECppReturnsRequestItemsUrl = `${this.baseUrl}api/CPPReturns/submit-request-jde`;

  public deleteCppReturnRequestUrl = `${this.baseUrl}api/CPPReturns/delete-return-request`;

  public accountUserCppReturnRequestUrl = `${this.baseUrl}api/CPPReturns/get-account-user-list`;

  // Get seed return Delivery To Account data
  public getCppReturnsDeliverToFacilityDataUrl = `${this.baseUrl}api/CPPReturns/get-deliver-to-facility/Account/{{accountNumber}}/ParentAccount/{{shipToAccountParentNumber}}`;

  // Get return request header id by inputs value for draft
  public getDraftCppReturnsRequestDataUrl = `${this.baseUrl}api/CPPReturns/get-draft-return-request/Account/{{accountNumber}}`;

  // Get seed return, return master data
  public getCppReturnsReturnMasterDataUrl = `${this.baseUrl}api/CPPReturns/get-return-master/Company/{{companyCode}}`;

  // Get return request header id by inputs value for draft
  public getDraftContainerReturnsRequestDataUrl = `${this.baseUrl}api/ContainerReturns/get-draft-return-request/Account/{{accountNumber}}`;

  // Get seed return  edit order details
  public getContainerReturnsRequestEditDetailDataUrl = `${this.baseUrl}api/ContainerReturns/get-edit-request-data`;

  public getCppContainerReturnsDeliverToFacilityDataUrl = `${this.baseUrl}api/ContainerReturns/get-deliver-to-facility/Account/{{accountNumber}}/ParentAccount/{{shipToAccountParentNumber}}`;

  public cppContainerReturnsAccountListUrl = `${this.baseUrl}api/ContainerReturns/account-list`;

  public cppContainerReturnsTypeUrl = `${this.baseUrl}api/ContainerReturns/return-type`;

  // /save return request
  public saveContainerReturnsRequestItemsUrl = `${this.baseUrl}api/ContainerReturns/save-return-request`;

  // /get container return landing page data
  public getContainerReturnRequestListUrl = `${this.baseUrl}api/ContainerReturns/get-return-request-list`;

  // /submit to jde return request
  public submitToJDEContainerReturnsRequestItemsUrl = `${this.baseUrl}api/ContainerReturns/submit-request-jde`;

  // Get Container Return Item Number data
  public getContainerReturnsItemNumberDataUrl = `${this.baseUrl}api/ContainerReturns/get-item-numbers`;

  // Get shipping availability report data url
  public getShippingAvailabilityReportUrl = `${this.baseUrl}api/ShippingAvailability/get-availability-report-data`;

  // Get SRA Orders Item Number data
  public getSraOrdersItemNumberDataUrl = `${this.baseUrl}api/CPPSROOrder/get-item-numbers`;

  // Get SRA Orders Crop Year data
  public getSroCropYearListUrl = `${this.baseUrl}api/CPPSROOrder/get-sro-crop-year`;

  // Get Sra orders list
  public getSraOrdersRequestUrl = `${this.baseUrl}api/CPPSROOrder/get-cpp-sro-orders`;

  // Get Place Sra orders list
  public getSraPlacedOrdersRequestUrl = `${this.baseUrl}api/CPPSROOrder/get-sro-place-orders`;

  //Delete SRA Order
  public deleteSRAOrderUrl = `${this.baseUrl}api/CPPSROOrder/delete-cpp-sro-order`;

  // Get SRA Order request access
  public getSraOrderRequestAccessUrl = `${this.baseUrl}api/CPPSROOrder/get-sro-order-request-access`;

  // Delete SRO Request Items
  public deleteSRORequestItems = `${this.baseUrl}api/CPPSROOrder/delete-sro-request-items`;

  // Get Filter Data for Approve and Review
  public getSraOrdersFilterDataReviewApprove = `${this.baseUrl}api/CPPSROOrder/get-filter-data-review-approve`;

  // Get All Requests Data for Approve and Review
  public getSraOrdersRequestsReviewApprove = `${this.baseUrl}api/CPPSROOrder/get-all-requests-review-approve`;
  public approveSRARequest = `${this.baseUrl}api/CPPSROOrder/approve-sra-request`;

  // Get account SDM data
  private getAccountSDMReasonCodeForSRODataUrl = 'api/CPPSROOrder/accountsdm-reasoncode-data';

  private getCppItemMasterDetailsForSRODataUrl = 'api/CPPSROOrder/get-sro-item-master-details';

  private getAllCppSroItemListDataUrl = 'api/CPPSROOrder/get-item-list';

  private setFavoriteForSROUrl = 'api/CPPSROOrder/set-favorite';

  private getSroErrorOrdersUrl = 'api/CPPSROOrder/get-sro-error-orders';
  private getSroDeliverToFacilityDataUrl = 'api/CPPSROOrder/get-deliver-to-facility';
  private deleteSroOrderItemsUrl = 'api/CPPSROOrder/delete-order-items';
  private resubmitSroOrderdataUrl = 'api/CPPSROOrder/resubmit-order';
  private resubmitSroOrdersListdataUrl = 'api/CPPSROOrder/resubmit-orders-list';

  // Seed Reservation
  private relSeedReservationUrl = 'api/SeedReservation/get-landing-data';
  private relSeedReservationConfUrl = 'api/SeedReservation/get-confirmation-data';
  private relSeedReservationAccountListUrl = 'api/SeedReservation/account-list';
  public exportToExcelSeedReservationDataUrl = 'api/SeedReservation/export-to-excel';
  public exportReconciliationToExcelSeedReservationDataUrl = 'api/SeedReservation/export-reconciliation-to-excel';
  public relSeedReservationMasterDataUrl = 'api/SeedReservation/master-data';
  private saveSeedReservationUrl = 'api/SeedReservation/save-seed-reservation';
  private exisitngDataSeedReservationURL = 'api/SeedReservation/get-existing-request';
  private relSeedReservationSalesAccountListUrl = 'api/SeedReservation/sales-account-list'
  public downloadPdfForSeedReseravtaionMobileUrl = 'api/SeedReservation/FileShareMobilePDFURL';
  public deleteSeedReseravtaionUrl = 'api/SeedReservation/delete-reservation';
  public getRetailerAccountIDUrl = 'api/SeedReservation/get-retail-accountId';
  // Seed Reconciliation
  private relSeedReservationReconciliationConfUrl = 'api/SeedReservationReconciliation/get-reconciliation-confirmation-data';
  private getProductIntialSetupUrl = 'api/SeedReservationReconciliation/get-product-intial-setup';

  // Seed Reconciliation
  private getReconciliationProductAvailabilityUrl = 'api/SeedReservationReconciliation/get-reconciliation-product-availability';
  private relGetHybridVarietyPackageSizeListUrl = 'api/SeedReservationReconciliation/get-hybrid-variety-package-sizes';
  private relSeedResGrowerOrderItemsUrl = 'api/SeedReservationReconciliation/seed-reservation-grower-order-items';
  private relSeedResGrowerListUrl = 'api/SeedReservationReconciliation/seed-res-grower-list';
  private relSeedResAccountListUrl = 'api/SeedReservationReconciliation/seed-res-account-list';
  private relSeedResGrowerOrderAddUpdateUrl = 'api/SeedReservationReconciliation/add-edit-product-booking';
  private getReconciliationProductAvailabilityHybridVarietyUrl = 'api/SeedReservationReconciliation/get-reconciliation-product-availability-hybrid-variety';
  private getReconciliationHybridVarietyProductListUrl = 'api/SeedReservationReconciliation/get-reconciliation-hybrid-variety-product-list';


  // ai chat
  private aiResposeUrl = 'api/ai/airesponse';
  private aiCppProductSeachUrl = 'api/ai/cpp-product-search';
  private aiResetUrl = 'api/ai/reset-session';
  private aiMenuUrl = 'api/ai/menu';
  private aitrackingemailUrl = 'api/ai/tracking-email';
  private aiReviewCppOrderUrl = 'api/ai/review-cpp-order';
  private aiPlaceCppOrderUrl = 'api/ai/place-cpp-order';
  private sfchatUrl = 'api/salesforcechat/conversation';
  private sfmessageUrl = 'api/salesforcechat/send-message';
  private recentChatUrl = 'api/salesforcechat/recentchat';
  private closeConversationUrl = 'api/salesforcechat/endconversation';
  private sendsfTranscriptUrl = 'api/salesforcechat/emailtranscript';
  private userSelectedAccountForChatUrl = 'api/ai/userselectedAccount';
  // send Return Request confirmation email
  sendProductAvailabilityEmail(): string {
    return this.baseUrl + this.getEmailProductAvailabilityListUrl;
  }

  exportProductAvailabilityList(): string {
    return this.baseUrl + this.getExportProductAvailabilityListUrl;
  }

  // Get Product Availability List Url for Shipping Availability Report
  public getEmailProductAvailabilityListUrl = 'api/ShippingAvailability/email-product-list';

  public getExportProductAvailabilityListUrl = 'api/ShippingAvailability/export-report';

  // Header->
  // Get Year data for Year dropdown
  getCropYearUrl(): string {
    return this.baseUrl + this.relCropYearUrl;
  }
  // Get Company data for Company dropdown
  getCompanyCodeUrl(): string {
    return this.baseUrl + this.relCompanyCodeUrl;
  }

  getCompanyNameUrl(): string {
    return this.baseUrl + this.relCompanyNameUrl;
  }
  // Get Company data for Company dropdown
  updateCurrentSessionUrl(): string {
    return this.baseUrl + this.relUpdateCurrentSessionUrl;
  }

  postFileForPdf(): string {
    return this.baseUrl + this.getBasePdfUrl;
  }
  postFileForSotPdf(): string {
    return this.baseUrl + this.getBasePdfSotUrl;
  }

  postFileForSeedPdf(): string {
    return this.baseUrl + this.getSeedBasePdfUrl;
  }

  postFileSeedPdf(): string {
    return this.baseUrl + this.getSeedPdfUrl;
  }

  getTestPdfUrlfromBaseFile(): string {
    return this.baseUrl + this.getTestPdfUrlfromBase;
  }

  // Landing Page->
  // Get Grower Order List
  getGrowerOrderUrl(): string {
    return this.baseUrl + this.relGrowerDetailUrl;
  }

  getSeedReservationLandingDataUrl(): string {
    return this.baseUrl + this.relSeedReservationUrl;
  }

  getSeedReservationConfirmationDataUrl(): string {
    return this.baseUrl + this.relSeedReservationConfUrl;
  }
  getSeedReservationReconciliationConfirmationDataUrl(): string {
    return this.baseUrl + this.relSeedReservationReconciliationConfUrl;
  }

  getReconciliationProductAvailability(): string {
    return this.baseUrl + this.getReconciliationProductAvailabilityUrl;
  }
  getHybridVarietyPackageSizeListUrl(): string {
    return this.baseUrl + this.relGetHybridVarietyPackageSizeListUrl;
  }
  getProductIntialSetup(): string {
    return this.baseUrl + this.getProductIntialSetupUrl;
  }
  
  getSeedReservationAccountListUrl(): string {
    return this.baseUrl + this.relSeedReservationAccountListUrl;
  }
  getSeedReservationSalesAccountListUrl(): string {
    return this.baseUrl + this.relSeedReservationSalesAccountListUrl;
  }
  getSeedReservationMasterDataUrl(): string {
    return this.baseUrl + this.relSeedReservationMasterDataUrl;
  }

  SaveSeedReservationOrderUrl(): string {
    return this.baseUrl + this.saveSeedReservationUrl;
  }

  DeleteReservationOrderUrl(): string {
    return this.baseUrl + this.deleteSeedReseravtaionUrl;
  }

  GetReailerAccountIDUrl(): string {
    return this.baseUrl + this.getRetailerAccountIDUrl;
  }

  getExisitngSeedReservationURL(): string {
    return this.baseUrl + this.exisitngDataSeedReservationURL;
  }

  getSeedReservationPdfUrl(): string {
    return this.baseUrl + this.downloadPdfForSeedReseravtaionMobileUrl;
  }

  getReconciliationProductAvailabilityHybridVariety(): string {
    return this.baseUrl + this.getReconciliationProductAvailabilityHybridVarietyUrl;
  }

  getReconciliationHybridVarietyProductList(): string {
    return this.baseUrl + this.getReconciliationHybridVarietyProductListUrl;
  }

  // Get Grower order items
  getSeedResGrowerOrderItemsUrl(): string {
    return this.baseUrl + this.relSeedResGrowerOrderItemsUrl;
  }

  // Get Grower List
  getSeedResGrowerListUrl(): string {
    return this.baseUrl + this.relSeedResGrowerListUrl;
  }

  // Get Account details for Account dropdown
  getSeedResAccountListUrl(): string {
    return this.baseUrl + this.relSeedResAccountListUrl;
  }

  // Get Account details for Account dropdown
  seedResGrowerOrderAddUpdateUrl(): string {
    return this.baseUrl + this.relSeedResGrowerOrderAddUpdateUrl;
  }

  // Get Dealer Order List
  geDealerOrderUrl(): string {
    return this.baseUrl + this.relDealerOrdersListUrl;
  }
  // Get Account details for Account dropdown
  getAccountListUrl(): string {
    return this.baseUrl + this.relAccountListUrl;
  }
  // Get Account detail
  getAccountInfoUrl(): string {
    return this.baseUrl + this.relAccountInfoUrl;
  }

  // Get Paertner Website SSO Urls
  getPartnerWebsiteUrl() {
    return this.baseUrl + this.relPartnerWebsiteUrl;
  }

  // Get Paertner Website SSO Urls
  getCropEdgeWebsiteUrl() {
    return this.baseUrl + this.relCropEdgeWebsiteUrl;
  }
  // Dealer->
  // Get Dealer order list
  getDealerOrdersListUrl(): string {
    return this.baseUrl + this.relDealerOrdersListUrl;
  }

  // Get Validate EaModifiable Items Url
  getValidateEaModifiableItemsUrl(): string {
    return this.baseUrl + this.relDealerOrderValidateEaItemsUrl;
  }
  // Get Ea Minimum Unit Exception Url
  getEaMinimumUnitExceptionUrl(): string {
    return this.baseUrl + this.relDealerOrderGetEaMinExpUrl;
  }

  UpdateEaUnitsItemsUrl(): string {
    return this.baseUrl + this.relDealerOrderModifyEaUnitsUrl;
  }
  // Get Dealer order detail
  getDealerOrderItemsUrl(): string {
    return this.baseUrl + this.relDealerOrderItemsUrl;
  }
  // Get Dealer detail
  getDealerDetailUrl(): string {
    return this.baseUrl + this.relDealerDetailUrl;
  }
  // Get Dealer order detail
  getDealerOrderDetailUrl(): string {
    return this.baseUrl + this.relDealerOrderDetailUrl;
  }
  // Get item growers detail
  getDealerGrowerDetailUrl(): string {
    return this.baseUrl + this.relItemGrowersDetailUrl;
  }
  // Update Dealer order
  getDealerOrderUpdateUrl(): string {
    return this.baseUrl + this.relDealerOrderUpdateUrl;
  }
  // Add Dealer order
  getDealerOrderAddUrl(): string {
    return this.baseUrl + this.relDealerOrderAddUrl;
  }
  // Get Modify item details
  getModifyItemUrl(): string {
    return this.baseUrl + this.relGetModifyItemUrl;
  }
  // Get Modify item details
  calculateEAUnitsModifyItemUrl(): string {
    return this.baseUrl + this.relCalculateEAUnitsModifyItemUrl;
  }

  getcheckUser4InternalTransferUrl(): string {
    return this.baseUrl + this.checkUser4InternalTransferUrl;
  }

  // Get Account details for Account dropdown
  getDelearAccountListUrl(): string {
    return this.baseUrl + this.deleerToAccountListUrl;
  }

  // Get To item details for ea swap
  getDealerOrderToItemUrl(): string {
    return this.baseUrl + this.relDealerOrderToItemUrl;
  }

  // update ea swap order
  eaSwapUpdateOrderUrl(): string {
    return this.baseUrl + this.relEaSwapUpdateOrderUrl;
  }

  // get ea modifiable units
  getFromEaModifiableUnitsUrl(): string {
    return this.baseUrl + this.relEaSwapModifiableUnitsUrl;
  }

  // Get EA item
  getDealerOrderEaItemsUrl(): string {
    return this.baseUrl + this.relDealerOrderEaItemsUrl;
  }

  // Update EA Add Product to order
  eaAddUpdateOrderUrl(): string {
    return this.baseUrl + this.relEaAddUpdateOrderUrl;
  }

  // Grower ->
  // Get Grower List
  getGrowerListUrl(): string {
    return this.baseUrl + this.relGrowerListUrl;
  }
  // Get Grower Detail
  getGrowerDetailUrl(): string {
    return this.baseUrl + this.relGrowerDetailUrl;
  }
  // Get Product change
  getGrowerProductChangeUrl(): string {
    return this.baseUrl + this.relGrowerProductChangeUrl;
  }
  // Add or update grower order
  growerOrderAddUpdateUrl(): string {
    return this.baseUrl + this.relGrowerOrderAddUpdateUrl;
  }

  // validateAccountForB2BEnablement
  validateAccountForB2BEnablement(): string {
    return this.baseUrl + this.relValidateAccountForB2BEnablement;
  }

  // Get Grower order items
  getGrowerOrderItemsUrl(): string {
    return this.baseUrl + this.relGrowerOrderItemsUrl;
  }

  // Get Grower order items
  checkHyridBtnAccess(): string {
    return this.baseUrl + this.relCheckHyrbridAddAccessUrl;
  }


  // Get Grower order items
  getGrowerHybridVarietyPackageSize(): string {
    return this.baseUrl + this.relGetHybridVarietyPackageSizeListGrwerUrl;
  }

  // Get Seller List
  getSellerListUrl(): string {
    return this.baseUrl + this.relGetSellerListUrl;
  }
  // Get Product Availability
  getProductAvailabilityUrl(): string {
    return this.baseUrl + this.relProductAvailabilityUrl;
  }
  // Get Grower order list
  getGrowerAccountUrl(): string {
    return this.baseUrl + this.relGrowerListByAccountUrl;
  }
  // Get Grower list by account
  getGrowerSearchUrl(): string {
    return this.baseUrl + this.relGrowerSearchUrl;
  }
  getGrowerPDFdataUrl(): string {
    return this.baseUrl + this.getGrowerPdfDataUrl;
  }
  // MasterData->
  // Get Item Number List
  getItemNumberMasterUrl(): string {
    return this.baseUrl + this.relItemNoMasterUrl;
  }

  // Get Master Data List
  getMasterDataUrl(): string {
    return this.baseUrl + this.relMasterDataUrl;
  }

  // Get Master Data List
  geHybridVarietyMasterDataUrl(): string {
    return this.baseUrl + this.relHybridVarietyMasterUrl;
  }

  // Get Master Data List
  getCPPFilterDataUrl(): string {
    return this.baseUrl + this.cppPriceListFilterDataUrl;
  }
  // Get Master Data List
  getFilterDataUrl(): string {
    return this.baseUrl + this.relFilterDataUrl;
  }

  getFilterDataPrepayUrl(): string {
    return this.baseUrl + this.relFilterDataPrepayUrl;
  }
  // Get Master Data List
  getGrowerSearchDataUrl(): string {
    return this.baseUrl + this.relGrowerSearchDataUrl;
  }

  // Get Grower Search Api
  getGrowerSearchApiUrl(): string {
    return this.baseUrl + this.relGrowerSearchApiUrl;
  }

  // Get Message Configuration By Code
  getMessageConfigurationUrl(): string {
    return this.baseUrl + this.relgetMessageConfigurationApiUrl;
  }

  getSeasonBannerUrl() {
    return this.baseUrl + this.seasonBannerURL;
  }

  getaddNewGrowerUrl(): string {
    return this.baseUrl + this.relAddNewGrowerUrl;
  }

  NewGrowerAddToSystemUrl(): string {
    return this.baseUrl + this.relNewGrowerAddToSystemUrl;
  }

  requestNewGrowerUrl(): string {
    return this.baseUrl + this.relrequestNewGrowerUrl;
  }

  mapOrFetchGmkUrl(): string {
    return this.baseUrl + this.relMapOrFetchGmkUrl;
  }

  // Order Transfer->
  // Save Grower to Grower transfer
  saveG2GTransferUrl(): string {
    return this.baseUrl + this.relG2FTansferUrl;
  }

  // Order transfer ->
  // Save Grower to Grower transfer from one Dealer to another
  saveG1D1G2D2FTansferUrl(): string {
    return this.baseUrl + this.relG1D1G2D2FTansferUrl;
  }

  // Get allocation availability details
  getAllocationAvailabilityUrl(): string {
    return this.baseUrl + this.relAllocationAvailabilityUrl;
  }

  getInternalAllocationAvailabilityUrl(): string {
    return this.baseUrl + this.relInternalAllocationAvailabilityUrl;
  }

  // Dealer order transfer->
  // Save dealer order transfer
  saveD2DTransferUrl(): string {
    return this.baseUrl + this.relD2DTansferUrl;
  }

  validateTransferDealerOrderUrl(): string {
    return this.baseUrl + this.relValidateTransferDealerOrderUrl;
  }

  // Save internal dealer order transfer
  saveD2DinternalTransferUrl(): string {
    return this.baseUrl + this.relD2DInternalTansferUrl;
  }
  validateD2DinternalTransferUrl(): string {
    return this.baseUrl + this.relD2DValidateInternalTansferUrl;
  }
  // Get item growers detail
  getDealerAccountListUrl(): string {
    return this.baseUrl + this.relDealerAccountListUrl;
  }

  // Get EA status for dealer order
  getDealerEaStatusUrl(): string {
    return this.baseUrl + this.relGetDealerEAStatusUrl;
  }
  // User Security->
  getAccountListingUrl(): string {
    return this.baseUrl + this.relAccountListingUrl;
  }
  getCropEdgeAccountListingUrl(): string {
    return this.baseUrl + this.relCropEdgeAccountListUrl;
  }
  // User Security->
  validateEvolveUrl(): string {
    return this.baseUrl + this.relValidateEvolveUrl;
  }

  // User Security->
  saveAddToAccountUrl(): string {
    return this.baseUrl + this.relSaveAddToAccountUrl;
  }

  removeUserSelectedAccountUrl(): string {
    return this.baseUrl + this.relRemoveUserSelectedAccountUrl;
  }

  checkSraAccountAccessUrl(): string {
    return this.baseUrl + this.checkSraAccountAccess;
  }
  checkEdlpAccessUrl(): string {
    return this.baseUrl + this.checkEdlpAccess;
  }
  checkSraApproversAccessUrl(): string {
    return this.baseUrl + this.checkSraApproversAccess;
  }
  // User Security->
  getChatAccessUrl(): string {
    return this.baseUrl + this.relGetChatAccessUrl;
  }

  getGetLoginAccountIdUrl(): string {
    return this.baseUrl + this.relgetGetLoginAccountIdUrl;
  }

  // Seed Fulfillment->
  // Get unsbmitted draft list
  getUnsubmittedDraftUrl(): string {
    return this.baseUrl + this.unsubmittedDraft;
  }
  // Get unsbmitted draft list
  getSubmittedRequestUrl(): string {
    return this.baseUrl + this.submittedRequest;
  }
  // Get ShipToAccounts for Fulfillment
  getReleaseFilterDataUrl(): string {
    return this.baseUrl + this.getReleaseFilterData;
  }
  // Get release order items
  getReleaseOrderItemsUrl(): string {
    return this.baseUrl + this.releaseOrderItems;
  }
  // Get Modifiy release order items
  getModifyReleaseOrderItemsUrl(): string {
    return this.baseUrl + this.modifyReleaseOrderItems;
  }
  // Get Seed Fulfilment Breakdown Lots Url
  getSeedFulfillmentItemAvailabilityByLotUrl(): string {
    return this.baseUrl + this.seedFulfillmentitemAvailabilityByLot;
  }

  // Add release items lot
  addReleaseItemsLotUrl(): string {
    return this.baseUrl + this.addReleaseItemsLot;
  }
  // Add release items lot
  getPalletAndSeedWeightUrl(): string {
    return this.baseUrl + this.getPalletAndSeedWeight;
  }
  // Add Update Release Order
  addUpdateReleaseOrderUrl(): string {
    return this.baseUrl + this.addUpdateReleaseOrder;
  }
  // Delete release item
  deleteReleaseItem(): string {
    return this.baseUrl + this.releaseOrderDelete;
  }
  // Place multiple JDE Order
  placeMultipleJDEOrderUrl(): string {
    return this.baseUrl + this.placeMultipleJDEOrder;
  }
  // Get Release Data
  getReleaseDataUrl(): string {
    return this.baseUrl + this.releaseDataUrl;
  }
  // Get Request Type data
  getRequestTypeUrl(): string {
    return this.baseUrl + this.requestTypeUrl;
  }
  // Get Request Type data
  getDeliveryInstructionsUrl(): string {
    return this.baseUrl + this.deliveryInstructions;
  }
  // Get filter unsubmitted release order
  getFilteredUnSubmittedReleaseOrderUrl(): string {
    return this.baseUrl + this.filteredUnSubmittedReleaseOrder;
  }
  // Get filter submitted release order
  getFilteredSubmittedReleaseOrderUrl(): string {
    return this.baseUrl + this.filteredSubmittedReleaseOrder;
  }
  // Place single JDEOrderurl
  placeSingleJDEOrderUrl(): string {
    return this.baseUrl + this.placeSingleJDEOrder;
  }

  //  Get Request Date Url
  getRequestdateUrl(): string {
    return this.baseUrl + this.getrequestdate;
  }

  getUnSubmittedReportUrl(): string {
    return this.baseUrl + this.unSubmittedReportUrl;
  }

  getSubmittedReportUrl(): string {
    return this.baseUrl + this.submittedReportUrl;
  }

  // Get can item list for cbox
  getCanItemListForCboxUrl(): string {
    return this.baseUrl + this.canItemListForCboxUrl;
  }

  // Sign Out Url
  signOutUrl(): string {
    return this.baseUrl + this.signOut;
  }

  // Get product url
  getProductsUrl(): string {
    return this.baseUrl + this.getProducts;
  }

  // Get product url
  getProductsAvailabilityReportUrl(): string {
    return this.baseUrl + this.getProductsAvailabilityReport;
  }

  // Get Product Availabilty Email Report
  getProductsAvailabilityEmailReportUrl(): string {
    return this.baseUrl + this.getProductsAvailabilityEmailReport;
  }

  // Get report account list
  getReportAccountListUrl(): string {
    return this.baseUrl + this.getReportAccountList;
  }

  // Get report filter data url
  getReportFilterUrl(): string {
    return this.baseUrl + this.getReportFilterDataUrl;
  }

  // Get quick search report filter data url
  getQuickSearchReportFilterUrl(): string {
    return this.baseUrl + this.getQuickSearchFilterDataUrl;
  }

  // Get substitution order report filter data url
  getSubstitutionOrderReportFilterUrl(): string {
    return this.baseUrl + this.getSubstitutionOrderReportDataUrl;
  }

  // Dealer Audit
  getDealerAuditAccountListUrl(): string {
    return this.baseUrl + this.getDARAccountUrl;
  }

  // Grower Audit
  getGrowerAuditAccountListUrl(): string {
    return this.baseUrl + this.getGARAccountUrl;
  }

  // Get Dealer Order Audit Log Url
  getDealerOrderAuditLogUrl(): string {
    return this.baseUrl + this.getDealerOrderAuditLog;
  }

  // Get Dealer Order Audit Log Url
  getGrowerOrderAuditLogUrl(): string {
    return this.baseUrl + this.getGrowerOrderAuditLog;
  }

  // show Hybrid Variety PackageSize Url
  getShowHybridVarietyPackageSizeUrl(): string {
    return this.baseUrl + this.getShowHybridVarietyPackageSize;
  }

  // Get report filter data url
  getDistrictFilterUrl(): string {
    return this.baseUrl + this.getDistrictDataFilterUrl;
  }

  // Get report filter data url
  getAttachedAccountListUrl(): string {
    return this.baseUrl + this.getAttachedAccountDataUrl;
  }

  // Get report filter data url
  getUserIdListUrl(): string {
    return this.baseUrl + this.getUserIdsDataUrl;
  }

  // Set emulation url
  setEmulationUrl(): string {
    return this.baseUrl + this.setEmulation;
  }

  // Clear Emulation url
  clearEmulationUrl(): string {
    return this.baseUrl + this.clearEmulation;
  }

  // Get total order summary filter data url
  getTotalOrderSummaryDataUrl(): string {
    return this.baseUrl + this.getTotalOrderSummaryUrl;
  }

  //Get User Report Filter
  getUserReportFilterUrl(): string {
    return this.baseUrl + this.getUserReportFiltersUrl;
  }

  //Update User Report Filter
  updateUserReportFilterUrl(): string {
    return this.baseUrl + this.updateUserReportFiltersUrl;
  }

  //Delete User Report Filter
  deleteUserReportFilterUrl(): string {
    return this.baseUrl + this.deleteUserReportFiltersUrl;
  }

  //Add User Report Filter
  addUserReportFilterUrl(): string {
    return this.baseUrl + this.addUserReportFiltersUrl;
  }

  //Get Active & Pending Contracts Data
  getActivePendingClosedContractsDataUrl(): string {
    return this.baseUrl + this.getActivePendingClosedContractsUrl;
  }

  // Get Contract Detail
  getContractDetailDataUrl(): string {
    return this.baseUrl + this.getContractDetailUrl;
  }

  // Get Seed Prepay Data
  getSeedPrePayContractDataUrl(): string {
    return this.baseUrl + this.getSeedPrePayContractsUrl;
  }

  // get cancel contract request
  cancelContractRequestUrl(): string {
    return this.baseUrl + this.getCancelContractRequestUrl;
  }
  // Add update contract request url
  addUpdateContractRequestUrl(): string {
    return this.baseUrl + this.getAddUpdateContractRequestUrl;
  }
  // Get prepay detail url
  getPrepayDetailDataUrl(): string {
    return this.baseUrl + this.getPrepayDetailUrl;
  }
  //
  getCropYearDataUrl(): string {
    return this.baseUrl + this.getCropYearDetailDataUrl;
  }
  getTermsAndConditionByRefrenceName(): string {
    return this.baseUrl + this.getTermsAndConditionByRefrenceNameUrl;
  }

  // Get Shippable Products Report url
  getShippableProductsReportUrl(): string {
    return this.baseUrl + this.getShippableProductsUrl;
  }

  // Get Dealer Order Audit Log Url
  getReleaseItemsAuditLogUrl(): string {
    return this.baseUrl + this.getReleaseItemsAuditLog;
  }

  // Get Cpp Item Number List
  getCppItemNumberData(): string {
    return this.baseUrl + this.getCppItemNumberDataUrl;
  }

  // Get CPP Parent Item List Data
  getCppParentItemNumberList(): string {
    return this.baseUrl + this.getCppParentItemNumberDataUrl;
  }

  // Get Cpp Disclaimer Message
  GetDisclaimerMessage(): string {
    return this.baseUrl + this.getDisclaimerMessageDataUrl;
  }
  GetSroDisclaimerMessage(): string {
    return this.baseUrl + this.getSroDisclaimerMessageDataUrl;
  }

  // Get Cpp Item Number List
  getCppItemNumberDataWithCPP_N(): string {
    return this.baseUrl + this.getCppItemNumberDataWithCPP_N_Url;
  }

  // Get Cpp Item data for Add Product Slider
  getAllCppItemListData(): string {
    return this.baseUrl + this.getAllCppItemListDataUrl;
  }

  // Delete item from CPP cart
  deleteFromCartData(): string {
    return this.baseUrl + this.deleteFromCartDataUrl;
  }

  getAllCppSroItemListData(): string {
    return this.baseUrl + this.getAllCppSroItemListDataUrl;
  }

  // Get Cpp Item Master Details for Add Product Slider

  getCppItemMasterDetailsData(): string {
    return this.baseUrl + this.getCppItemMasterDetailsDataUrl;
  }

  // Get CPP order items list
  getCppOrderItemsData(): string {
    return this.baseUrl + this.getCppOrderItemsUrl;
  }

  // Get Quote order items list
  getQuoteOrderItemsData(): string {
    return this.baseUrl + this.getQuoteOrderItemsUrl;
  }

  // Get Quote order items list Export
  getQuoteOrderItemsExportData(): string {
    return this.baseUrl + this.getQuoteOrderItemsExportUrl;
  }

  // Get Cpp Error orders list
  getCppErrorOrdersData(): string {
    return this.baseUrl + this.getCppErrorOrdersUrl;
  }

  // Get Cpp Ship To Facility List
  getCppShipToFacilityData(): string {
    return this.baseUrl + this.getCppShipToFacilityDataUrl;
  }
  getSraShipToFacilityData(): string {
    return this.baseUrl + this.getSraShipToFacilityDataUrl;
  }
  // Get Cpp Deliver To Facility List
  getCppDeliverToFacilityData(): string {
    return this.baseUrl + this.getCppDeliverToFacilityDataUrl;
  }
  getSroDeliverToFacilityData(): string {
    return this.baseUrl + this.getSroDeliverToFacilityDataUrl;
  }
  getSroSoldToFacilityData(): string {
    return this.baseUrl + this.getSroSoldToFacilityDataUrl;
  }

  // Get Cpp Sold To Facility List
  getCppSoldToFacilityData(): string {
    return this.baseUrl + this.getCppSoldToFacilityDataUrl;
  }

  // Get CPP Email Price List

  getCppEmailProductListUrl(): string {
    return this.baseUrl + this.emailCPPProductListUrl;
  }

  // Get CPP Existing Order Detail
  getCppShipToOrderDetail(): string {
    return this.baseUrl + this.getCppShipToOrderDetailUrl;
  }
  getSroShipToOrderDetail(): string {
    return this.baseUrl + this.getSroShipToOrderDetailUrl;
  }


  getSroExistingOrders(): string {
    return this.baseUrl + this.getSroExistingOrderUrl;
  }
  getSroErrorOrdersData(): string {
    return this.baseUrl + this.getSroErrorOrdersUrl;
  }

  // Place Sro order url
  placeSroOrderRequest() {
    return this.baseUrl + this.getSraOrderRequestUrl;
  }

  getSroItemsSDM(): string {
    return this.baseUrl + this.getSroItemsSDMDataUrl;
  }
  getRequestDetailsForSelectedRecords() {
    return this.baseUrl + this.getRequestDetailsForSelectedRecordsUrl;
  }
  updateRequestDateForSelectedRecords() {
    return this.baseUrl + this.updateRequestDateUrl;
  }
  // Get OwnerPriceListAccessPermission
  getOwnerPriceListAccessPermissionUrl(): string {
    return this.baseUrl + this.OwnerPriceListAccessPermissionUrl;
  };

  // Save create order url
  saveOrder() {
    return this.baseUrl + this.saveOrderdataUrl;
  }

  // Place create order url
  placeOrder() {
    return this.baseUrl + this.placeOrderdataUrl;
  }

  // Resubmit order url
  resubmitOrder() {
    return this.baseUrl + this.resubmitOrderdataUrl;
  }

  // Delete order Items url
  deleteOrderItems() {
    return this.baseUrl + this.deleteOrderItemsUrl;
  }
  deleteSroOrderItems() {
    return this.baseUrl + this.deleteSroOrderItemsUrl;
  }
  resubmitSroOrder() {
    return this.baseUrl + this.resubmitSroOrderdataUrl;
  }

  // Resubmit orders list data
  resubmitOrdersList() {
    return this.baseUrl + this.resubmitOrdersListdataUrl;
  }
  resubmitSroOrdersList() {
    return this.baseUrl + this.resubmitSroOrdersListdataUrl;
  }


  // Get Cpp order detail data
  getCppOrderDetailData(): string {
    return this.baseUrl + this.getCppOrderDetailDataUrl;
  }

  // Get Cpp Edit order detail data
  getCppEditOrderDetailData(): string {
    return this.baseUrl + this.getCppEditOrderDetailDataUrl;
  }
  getSroEditOrderDetailData(): string {
    return this.baseUrl + this.getSroEditOrderDetailDataUrl;
  }

  // Check for existing Draft Order
  checkExistingDraftOrder(): string {
    return this.baseUrl + this.checkExistingDraftOrderUrl;
  }

  // Get Cpp order detail data
  getCPPInstructionTypeList(): string {
    return this.baseUrl + this.getCPPInstructionTypeDataUrl;
  }

  // Get Cpp order detail data
  setFavorite(): string {
    return this.baseUrl + this.setFavoriteUrl;
  }
  setFavoriteForSRO(): string {
    return this.baseUrl + this.setFavoriteForSROUrl;
  }

  // Get Cpp order detail data
  setFavoritePricelist(): string {
    return this.baseUrl + this.setPriceListFavoriteUrl;
  }
  // Delete CPP Order
  deleteCppOrder(): string {
    return this.baseUrl + this.deleteCppOrderUrl;
  }

  // Get Order summary details
  getOrderSummaryDetails(): string {
    return this.baseUrl + this.getOrderSummaryDetailsUrl;
  }

  // send confirmation email
  sendCPPOrderConfirmationEmail(): string {
    return this.baseUrl + this.getCPPOrderConfirmationEmailUrl;
  }

  // get cpp report
  getCPPReport(): string {
    return this.baseUrl + this.getCPPReportUrl;
  }

  // CPP Product Label

  // get Product Label Account List

  getProductLabelAccountListUrl(): string {
    return this.baseUrl + this.productLabelAccountListUrl;
  }

  //get Product Label Items List

  getProductLabelItemsListUrl(): string {
    return this.baseUrl + this.productLabelItemsListUrl;
  }

  // cpp Save Product Label Order

  cppSaveProductLabelOrderUrl(): string {
    return this.baseUrl + this.saveProductLabelOrderUrl;
  }

  // get Product label orders
  getProductLabelOrdersData(): string {
    return this.baseUrl + this.getProductLabelOrdersUrl;
  }

  getProductLabelOrderDetails(): string {
    return this.baseUrl + this.getProductLabelOrderDetailsUrl;
  }

  getUnauthorizedProductWarningMessageUrl(): string {
    return this.baseUrl + this.unauthorizedProductWarningMsgUrl;
  }

  // CPP Price
  // Get Cpp Product list
  getCPPProductData(): string {
    return this.baseUrl + this.getCPPProductDataUrl;
  }
  // get cpp price list data exported
  getCPPPriceDataExported(): string {
    return this.baseUrl + this.getCPPPriceExportDataUrl;
  }
  // save/ remove ItemFavorite
  addRemoveItemFavorite(): string {
    return this.baseUrl + this.saveItemFavoriteUrl;
  }
  // send confirmation email
  EmailCppProductList(): string {
    return this.baseUrl + this.getCPPOrderConfirmationEmailUrl;
  }
  // Get Cpp Price list
  getPriceListAccount(): string {
    return this.baseUrl + this.getPriceListAccountUrl;
  }
  // Get Cpp Customer Price list
  getCPPCustomerPriceData(): string {
    return this.baseUrl + this.getCPPCustomerPriceDataUrl;
  }
  // get cpp price list data exported
  emailCPPPriceData(): string {
    return this.baseUrl + this.getCPPPriceExportDataUrl;
  }

  // CPP Manage Subscription
  getManageSubscriptionList(): string {
    return this.baseUrl + this.getManageSubscriptionUrl;
  }

  // Get LoginUser Status
  getSubscriptionStatus(): string {
    return this.baseUrl + this.getSubscriptionStatusUrl;
  }

  // CPP Report
  // Get Sulfur & Zinc Pricing Report Data
  getSulfurZincPricingReportData(): string {
    return this.baseUrl + this.getSulfurZincPricingReportUrl;
  }

  // Get AMS Pricing Report Data
  getAMSPricingReportData(): string {
    return this.baseUrl + this.getAMSPricingReportUrl;
  }

  // EDLP
  getEDLPConfigUrl(): string {
    return this.baseUrl + this.edlpConfigUrl;
  }

  getEDLPEligibleAccountsUrl(): string {
    return this.baseUrl + this.edlpEligibleAccountsUrl;
  }

  getEDLPPricingDataUrl(accountNumber: number): string {
    return this.baseUrl + this.edlpPricingDataUrl + '/' + accountNumber;
  }

  getEDLPLastRefreshDateUrl(): string {
    return this.baseUrl + this.edlpLastRefreshDateUrl;
  }

  getEDLPInitialDataUrl(): string {
    return this.baseUrl + this.edlpInitialDataUrl;
  }

  getEDLPExportExcelUrl(): string {
    return this.baseUrl + this.edlpExportExcelUrl;
  }

  getEDLPSubscriptionStatusUrl(): string {
    return this.baseUrl + this.edlpSubscriptionStatusUrl;
  }

  getEDLPUpdateSubscriptionUrl(): string {
    return this.baseUrl + this.edlpUpdateSubscriptionUrl;
  }


  // get manage subscription list for the report
  getPricingReportManageSubscriptionList(): string {
    return this.baseUrl + this.getPricingReportManageSubscriptionUrl;
  }

  // Add update pricing report subscription
  addUpdatePricingReportSubscription(): string {
    return this.baseUrl + this.getAddUpdatePricingReportSubscriptionUrl;
  }

  // Update Status
  updateStatus(): string {
    return this.baseUrl + this.getUpdateStatusUrl;
  }

  // Add update Subscription
  addUpdateSubscription(): string {
    return this.baseUrl + this.getAddUpdateSubscriptionUrl;
  }

  // Add Valid For Subscription
  isValidForSubscription(): string {
    return this.baseUrl + this.isValidForSubscriptionUrl;
  }

  // Licensing
  // Get licensing list
  getLicenseData(): string {
    return this.baseUrl + this.getLicenseListUrl;
  }
  // Get licensing filters list
  getLicenseFiltersData(): string {
    return this.baseUrl + this.getLicenseFiltersUrl;
  }
  // add update license data
  addUpdateDeleteGrowerLicenseData(): string {
    return this.baseUrl + this.getAddUpdateDeleteGrowerLicenseUrl;
  }
  // Get licensing report
  getLicenseReport(): string {
    return this.baseUrl + this.getLicenseReportUrl;
  }
  // Get licensing order detail
  getLicenseOrderDetail(): string {
    return this.baseUrl + this.getLicenseOrderDetailUrl;
  }

  // Get GrowerGLN
  getGrowerGLN(): string {
    return this.baseUrl + this.getGrowerGLNUrl;
  }

  // Get oti dashboard filter data
  getOtiDashboardFilter(): string {
    return this.baseUrl + this.getOtiFilterUrl;
  }

  // Get oti dashboard filter data
  getOtiOrderFilter(): string {
    return this.baseUrl + this.getOtiOrderFilterUrl;
  }

  // Get oti order list
  getOtiOrderList(): string {
    return this.baseUrl + this.getOtiOrdreUrl;
  }

  // Get oti order list
  getOtiOrderLandingList(): string {
    return this.baseUrl + this.getOtiOrderListUrl;
  }
  // Get oti Sedd order list
  getOtiSeedOrderLandingList(): string {
    return this.baseUrl + this.getOtiSeedOrderListUrl;
  }

  // Get oti export list
  getOtiExportList(): string {
    return this.baseUrl + this.getOtiExportUrl;
  }

  // OIP

  // Get oti Master Data list
  getFilterMasterDataOip(): string {
    return this.baseUrl + this.getFilterMasterDataOipUrl;
  }

  // Get oti Grid Data list
  getDataOip(): string {
    return this.baseUrl + this.getDataOipUrl;
  }
  getSeedSearchList(): string {
    return this.baseUrl + this.getSeedSearchListUrl;
  }
  // Get oti Summary data
  getOTISummaryData(): string {
    return this.baseUrl + this.getOTISummaryDataUrl;
  }
  // Get oti User Profile
  getOTIUserProfile(): string {
    return this.baseUrl + this.getOtiUserProfileUrl;
  }

  // SET oti default product segment
  setDefaultProductSegment(): string {
    return this.baseUrl + this.setOtiProductSegment;
  }
  // Get oti User Profile
  getOTIHistoryDays(): string {
    return this.baseUrl + this.getOtiHistoryDaysUrl;
  }

  // Get data for quote order details
  getQuoteOrderDetail(): string {
    return this.baseUrl + this.getQuoteOrderDetailUrl;
  }

  // Get data for quote order details
  getQuoteOrderProduct(): string {
    return this.baseUrl + this.getQuoteOrderProductUrl;
  }

  // Get data for quote order details
  getQuoteOrderAccess(): string {
    return this.baseUrl + this.getQuoteOrderAccessUrl;
  }

  // Get data for quote order details
  saveQuoteOrderDraft(): string {
    return this.baseUrl + this.saveQuoteOrderdataUrl;
  }

  // check Quote Existing Draft Order
  checkQuoteExistingDraftOrder(): string {
    return this.baseUrl + this.checkQuoteExistingDraftOrderUrl;
  }

  // Approve Or Reject Quote
  approveOrRejectQuote(): string {
    return this.baseUrl + this.approveOrRejectQuoteUrl;
  }

  // Close Quote
  closeQuote(): string {
    return this.baseUrl + this.closeQuoteUrl;
  }
  // submit sales order Quote
  submitSalesOrder(): string {
    return this.baseUrl + this.submitSalesOrderUrl;
  }

  // Get Quote Orders
  getQuoteOrder(): string {
    return this.baseUrl + this.getQuoteOrderUrl;
  }

  // Get data for quote order details
  getQuoteOrderSummary(): string {
    return this.baseUrl + this.getQuoteOrderSummaryUrl;
  }

  getTestPDF(): string {
    return this.baseUrl + this.getTestPDFUrl;
  }

  // send confirmation email
  sendQuoteOrderConfirmationEmail(): string {
    return this.baseUrl + this.getQuoteOrderConfirmationEmailUrl;
  }

  getProductLine(): string {
    return this.baseUrl + this.getProductLineUrl;
  }

  getWarningMessage(): string {
    return this.baseUrl + this.getWarningMessageUrl;
  }

  getCPPReturnInoculantWarningMessage(): string {
    return this.baseUrl + this.getCPPReturnsInoculantWarningMessageUrl;
  }

  getCPPReturnInoculantErrorMessage(): string {
    return this.baseUrl + this.getCPPReturnsInoculantErrorMessageUrl;
  }

  getInoculantRestriction(): string {
    return this.baseUrl + this.getInoculantRestrictionUrl;
  }

  getCPPReturnInoculantReportDistributionEmail(): string {
    return this.baseUrl + this.getCPPReturnInoculantReportDistributionEmailUrl;
  }

  getCommandCenterCppData(): string {
    return this.baseUrl + this.getCommandCenterCppDataUrl;
  }

  getCommandCenterSeedData(): string {
    return this.baseUrl + this.getCommandCenterSeedCppDataUrl;
  }

  getMessageCenterData(): string {
    return this.baseUrl + this.getMessageCenterDataUrl;
  }

  pinUnPinMessage(): string {
    return this.baseUrl + this.pinUnPinMessageDataUrl;
  }

  readMessage(): string {
    return this.baseUrl + this.readMessageDataUrl;
  }

  getKnowledgeCenterData(): string {
    return this.baseUrl + this.getknowledgeCenterDataUrl;
  }

  public getAPIPath(path: string, params: Object): string {
    let str = path;
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        str = str.split('{{' + key.toString() + '}}').join(params[key].toString());
      }
    }
    return str;
  }

  getAccountSDMReasonCodeData(): string {
    return this.baseUrl + this.getAccountSDMReasonCodeDataUrl;
  }
  getAccountSDMReasonCodeDataForSRO(): string {
    return this.baseUrl + this.getAccountSDMReasonCodeForSRODataUrl;
  }
  getSroItemMasterDetailsData(): string {
    return this.baseUrl + this.getCppItemMasterDetailsForSRODataUrl;
  }

  getItemsSDM(): string {
    return this.baseUrl + this.getItemsSDMDataUrl;
  }

  // Seed Returns

  // Get Process Access
  getProcessAccessForNonSoybean(): string {
    return this.baseUrl + this.getProcessAccessForNonSoybeanUrl;
  }

  // Get Return Period Validation Status
  getReturnPeriodValidation(): string {
    return this.baseUrl + this.getReturnPeriodValidationUrl;
  }

  // Get Account details for Account dropdown
  getSeedReturnAccountListUrl(): string {
    return this.baseUrl + this.seedReturnAccountListUrl;
  }

  // Get Account details for Account dropdown
  getSeedReturnFreightInstUrl(): string {
    return this.baseUrl + this.seedReturnFreightInstUrl;
  }

  // Get Account details for Account dropdown
  GetBannerMessageUrl(): string {
    return this.baseUrl + this.bannerMessageUrl;
  }

  // Get Account details for Account dropdown
  UpdateReturnRequestStatus(): string {
    return this.baseUrl + this.updateReturnRequestStatus;
  }

  // check OTI rders
  checkOTIOrdersForPOUrl(): string {
    return this.baseUrl + this.checkOTIOrdersUrl;
  }

  // Get Seed Return Item Number List
  getSeedReturnItemNumberData(): string {
    return this.baseUrl + this.getSeedReturnItemNumberDataUrl;
  }

  // Get return request list
  getreturnRequestData(): string {
    return this.baseUrl + this.getReturnRequestUrl;
  }

  // Get return request export list
  getreturnRequestExportData(): string {
    return this.baseUrl + this.getReturnRequestExportUrl;
  }

  // Get seed return Edit order detail data
  getReturnRequestEditDetailData(): string {
    return this.baseUrl + this.getReturnRequestEditDetailDataUrl;
  }

  // Get DSM Info
  getDSMData(): string {
    return this.baseUrl + this.getDsMInfoUrl;
  }

  // Get Invoice Number
  getInvoiceNumberList(): string {
    return this.baseUrl + this.getInvoiceNumberListUrl;
  }
  // Get Invoiced Products Items
  getInvoicedProductItems(): string {
    return this.baseUrl + this.getInvoicedProductItemsUrl;
  }
  // Get lot master Items
  getLotMasterItems(): string {
    return this.baseUrl + this.getLotMasterItemsUrl;
  }

  // Submit/Draft/Approval/Reject Return request
  saveReturnRequests(): string {
    return this.baseUrl + this.saveReturnRequestItemsUrl;
  }

  // Submit/Draft/Approval/Reject Return request
  submitForCreditAutoApproval(): string {
    return this.baseUrl + this.submitForCreditAutoApproveURL;
  }


  // Save Soybean Zero Dumps request

  saveSoybeanNoDumps(): string {
    return this.baseUrl + this.saveSoybeanNoDumpsUrl;
  }

  // Save Scale Tickets URL
  saveScaleTickets(): string {
    return this.baseUrl + this.saveReturnScaleTicketUrl;
  }

  // SubmitToJDE Return request
  submitToJDEReturnRequests(): string {
    return this.baseUrl + this.submitToJDEReturnRequestItemsUrl;
  }
  // Get products for manual tab
  getScaleTicketFile(): string {
    return this.baseUrl + this.getScaleTicketFileUrl;
  }

  // delete scale ticket
  deleteScaleTicket(): string {
    return this.baseUrl + this.deleteScaleTicketUrl;
  }

  // Delete CPP Order
  deleteReturnRequest(): string {
    return this.baseUrl + this.deleteReturnRequestUrl;
  }

  // Get Account User
  getAccountUser(): string {
    return this.baseUrl + this.accountUserRequestUrl;
  }

  // Get Scale Ticket file extentions text
  getScaleTicketFileExtensions(): string {
    return this.baseUrl + this.scaleTicketFileExtensionsUrl;
  }

  // Get data for blanket order details
  getBlanketOrderAccess(): string {
    return this.baseUrl + this.getBlanketOrderAccessUrl;
  }

  // Get blanket order items list
  getBlanketOrderItemsData(): string {
    return this.baseUrl + this.getBlanketOrderItemsUrl;
  }

  // Get blanket order Export list
  getblanetOrderExportList(): string {
    return this.baseUrl + this.getBlanketOrderExportItemsUrl;
  }

  // Get blanket shipto list
  getBlanketShipToListData(): string {
    return this.baseUrl + this.getBlanketShipToListUrl;
  }

  // Get Blanket Item data for Add Product Slider
  getAllBlanketItemListData(): string {
    return this.baseUrl + this.getAllBlanketItemListDataUrl;
  }

  // Get Order summary details for EA Order
  getEAOrderSummaryDetails(): string {
    return this.baseUrl + this.getEAOrderSummaryUrl;
  }

  // Get Edit Order for EA Order
  getBlanketEditOrder(): string {
    return this.baseUrl + this.getEABlanketEditUrl;
  }

  // Get Edit Order for EA Order
  getExisitingDraftOrder(): string {
    return this.baseUrl + this.getDraftOrderUrl;
  }

  uploadProductExcelData(): string {
    return this.baseUrl + this.uploadProductExcelUrl;
  }

  downloadProductExcelData(): string {
    return this.baseUrl + this.downloadProductExcelUrl;
  }

  // Place create order url
  placeBlanketOrder() {
    return this.baseUrl + this.placeBlanketOrderdataUrl;
  }

  // Place create order url
  saveBlanketOrder() {
    return this.baseUrl + this.saveBlanketOrderdataUrl;
  }

  // Post confirmation email
  private getBlanketOrderConfirmationEmailUrl = 'api/BlanketOrder/send-blanket-order-confirmation-email';

  // Delete Blanket order
  private deleteBlanketOrderURL = 'api/BlanketOrder/delete-blanket-order';

  // send confirmation email
  sendBlanketOrderConfirmationEmail(): string {
    return this.baseUrl + this.getBlanketOrderConfirmationEmailUrl;
  }

  // Delete Blanket Order
  deleteBlanketOrder(): string {
    return this.baseUrl + this.deleteBlanketOrderURL;
  }

  // Get all COI Location invoiced products for grid
  private getCoiProductItemsUrl = `${this.baseUrl}api/COIFullfillment/get-items-list`;

  // Check COI Access
  public checkCoiAccess = `${this.baseUrl}api/Common/get-coi-access`;

  // Get all COI Location invoiced products for grid
  getCoiProductItemsData(): string {
    return this.baseUrl + this.getCoiProductItemsUrl;
  }

  // // Check for existing COI Draft Order
  checkExistingCOIDraftOrder(): string {
    return this.baseUrl + this.checkExistingCOIDraftOrderUrl;
  }

  // Get Coi Sold To Facility List
  getCoiSoldToFacilityData(): string {
    return this.baseUrl + this.getCoiSoldToFacilityDataUrl;
  }

  // Get Coi Deliver To Facility List
  getCoiDeliverToFacilityData(): string {
    return this.baseUrl + this.getCoiDeliverToFacilityDataUrl;
  }

  // Get coi Ship To Facility List
  getCoiShipToAccountData(): string {
    return this.baseUrl + this.getCoiShipToAccountDataUrl;
  }

  // Get coi Ship To Facility List
  getCoiInstructionTypeData(): string {
    return this.baseUrl + this.getCoiInstructionTypeDataUrl;
  }

  // Get Coi Item Number List
  getCoiItemNumbersData(): string {
    return this.baseUrl + this.getCoiItemNumbersDataUrl;
  }

  // Get Coi Edit order detail data
  getCoiEditOrderDetailData(): string {
    return this.baseUrl + this.getCoiEditOrderDetailDataUrl;
  }

  // Place create order url
  placeCoiOrder() {
    return this.baseUrl + this.placeCoiOrderdataUrl;
  }

  // Save create order url
  saveCoiOrder() {
    return this.baseUrl + this.saveCoiOrderdataUrl;
  }

  getCoiAccountSDMData(): string {
    return this.baseUrl + this.getCoiAccountSDMDataUrl;
  }

  getCoiItemsSDM(): string {
    return this.baseUrl + this.getCoiItemsSDMDataUrl;
  }

  getCoiDeliveryChangeReasonDate(): string {
    return this.baseUrl + this.getCoiDeliveryReasonChangeUrl;
  }

  // Seed Replant
  // Get lot master Items
  getSeedReplantLotMasterItems(): string {
    return this.baseUrl + this.getSeedReplantLotMasterItemsUrl;
  }

  // delete Seed Replant draft request
  deleteSeedReplantDraftRequestDetail(): string {
    return this.baseUrl + this.deleteSeedReplantDraftRequest;
  }

  // send Seed Replant confirmation email
  sendSeedReplantNewRequestEmail(): string {
    return this.baseUrl + this.sendSeedReplantRequestEmail;
  }

  // Get Grower list by account
  getSeedReplantGrowerSearchUrl(): string {
    return this.baseUrl + this.relSeedReplantGrowerSearchUrl;
  }

  // Crop Loss
  // Get lot master Items
  getCropLossLotMasterItems(): string {
    return this.baseUrl + this.getCropLossLotMasterItemsUrl;
  }

  // delete Crop Loss draft request
  deleteCropLossDraftRequestDetail(): string {
    return this.baseUrl + this.deleteCropLossDraftRequest;
  }

  // send Crop Loss confirmation email
  sendCropLossNewRequestEmail(): string {
    return this.baseUrl + this.getCropLossNewRequestEmail;
  }

  getcppGetDeliveryInstructionListUrl(): string {
    return this.baseUrl + this.cppGetDeliveryInstructionListUrl;
  }
  getcppUserListUrl(): string {
    return this.baseUrl + this.cppGetUserListUrl;
  }

  // Get Seed Crop Associate Locations
  getSeedCropAssociateLocations(): string {
    return this.baseUrl + this.getSeedCropAssociateLocationsUrl;
  }

  // Get Seed Crop Associate Ship To Account data
  getSeedCropAssociateAccount(): string {
    return this.baseUrl + this.getSeedCropAssociateAccountUrl;
  }

  // Get Seed Crop Associate Deliver To data
  getSeedCropAssociateDeliverTo(): string {
    return this.baseUrl + this.getSeedCropAssociateDeliverToUrl;
  }

  // Get Seed Crop Associate Details Data
  getSeedCropDetailsData(): string {
    return this.baseUrl + this.getSeedCropDetailsDataUrl;
  }

  // Seed Crop Associate Place Order
  getSeedCropPlaceRequest(): string {
    return this.baseUrl + this.getSeedCropPlaceRequestUrl;
  }

  // Get Seed Crop Associate Landing Data
  GetSeedCropAssociatesLandingData(): string {
    return this.baseUrl + this.GetSeedCropAssociatesLandingDataUrl;
  }
  GetSeedCropAssociatesReconciliationLandingData(): string {
    return this.baseUrl + this.GetSeedCropAssociatesReconciliationLandingDataUrl;
  }

  // Get Seed Crop Associate Details Data
  GetReconcileVariety(): string {
    return this.baseUrl + this.getReconcileVariety;
  }

  // Get Seed Crop Associate Details Data
  AddUpdateReconcileOrder(): string {
    return this.baseUrl + this.addUpdateReconcileOrder;
  }


  // Get Seed Crop Associate Order Summary Data
  GetSeedCropAssociatesOrderSummaryData(): string {
    return this.baseUrl + this.GetSeedCropAssociatesOrderSummaryUrl;
  }

  // Get Seed Crop Associate Order Pdf Data
  GetSeedCropAssociatesPdfData(): string {
    return this.baseUrl + this.getAssociatePdfUrl;
  }

  // Get Seed Crop Associate Order Pdf Data
  AssociatePostFileForPdf(): string {
    return this.baseUrl + this.getMobileVersionPdfUrl;
  }

  // Get Inventory Location Landing Data 
  getInventoryLandingData(): string {
    return this.baseUrl + this.getInventoryLandingDataUrl;
  }

  // Get Inventory Location Landing Data 
  getInventoryMasterData(): string {
    return this.baseUrl + this.getInventoryMasterDataUrl;
  }

  // Get Inventory Location List 
  getInventoryLocationList(): string {
    return this.baseUrl + this.getInventoryLocationListUrl;
  }

    // Get Seed Crop Associate Details Data
  AddUpdateInvetoryOrder(): string {
    return this.baseUrl + this.addUpdateInventoryOrder;
  }

  checkCreateAccessForPlotSeed(): string {
    return this.baseUrl + this.checkCreateAccessForPlotSeedUrl;
  }
  getPlotSeedProductLines(): string {
    return this.baseUrl + this.getPlotSeedProductLinesUrl;
  }
  getPlotSeedMaturityData(): string {
    return this.baseUrl + this.getPlotSeedMaturitydataUrl;
  }
  getPlotSeedStatusList(): string {
    return this.baseUrl + this.getPlotSeedStatusListUrl;
  }

  getPgsOrderProductLines(): string {
    return this.baseUrl + this.getPgsOrderProductLinesUrl;
  }

  getPgsOrderLandingData(): string {
    return this.baseUrl + this.getPgsOrderLandingDataUrl;
  }

  getPgsPackDetails(): string {
    return this.baseUrl + this.getPgsPackDetailsUrl;
  }

  getPgsOrderExportData(): string {
    return this.baseUrl + this.getPgsOrderExportUrl;
  }
  
  // Get Plot Seed Landing Data
  getPlotSeedLandingData(): string {
    return this.baseUrl + this.getPlotSeedLandingDataUrl;
  }
  // Get Plot Seed Order Detail Data
  getPlotSeedDetailsData(): string {
    return this.baseUrl + this.getPlotSeedDetailDataUrl;
  }

  // Get Seed Crop Associate Report Data
  GetSeedCropReportData(): string {
    return this.baseUrl + this.getSeedCropAssociateReportUrl;
  }


  // Get Plot Seed Summary Data
  getPlotSeedOrderSummaryData(): string {
    return this.baseUrl + this.getPlotSeedOrderSummaryUrl;
  }
  // Get Seed Header Data for Create Order
  getPlotSeedCreateOrderHeaderData(): string {
    return this.baseUrl + this.getPlotSeedCreateOrderHeaderDataUrl;
  }
  // Get Seed Header Data for Create Order
  getPlotSeedOrderDateSetupData(): string {
    return this.baseUrl + this.getPlotSeedOrderDateSetupDataUrl;
  }
  // Get Plot Seed Ship To and Asc Accounts
  getPlotSeedShipToAscAccountsData(): string {
    return this.baseUrl + this.getPlotSeedShipToAscAccountDataUrl;
  }

  //Get Plot Seed Release Landing Data
  getPlotSeedReleaseData(): string {
    return this.baseUrl + this.getPlotSeedReleaseDataUrl;
  }

  // Get Plot Seed Order Ship To
  getPlotSeedOrderShipToData(): string {
    return this.baseUrl + this.getPlotSeedOrderShipToDataaUrl;
  }
  // Get Plot Seed Deliver To data
  getPlotSeedDeliverTo(): string {
    return this.baseUrl + this.getPlotSeedDeliverToUrl;
  }
  // Place Plot Seed Order
  placePlotSeedOrder(): string {
    return this.baseUrl + this.placePlotSeedOrderUrl;
  }
  // Get Seed Crop Associate Order Pdf Data
  GetPlotSeedOrderPdfData(): string {
    return this.baseUrl + this.getPlotSeedPdfUrl;
  }
  // Get Seed Crop Associate Order Pdf Data
  PlotSeedPostFileForPdf(): string {
    return this.baseUrl + this.getPlotSeedMobileVersionPdfUrl;
  }

  // Get Seed Crop Associate Order Pdf Data
  PlotSeedPlaceJDEOrderUrl(): string {
    return this.baseUrl + this.placePlotSeedJDEOrderUrl;
  }
  // Get Seed Header Data for Release Order
  getPlotSeedReleaseOrderHeaderData(): string {
    return this.baseUrl + this.getPlotSeedReleaseOrderHeaderDataUrl;
  }
  // Get Pallet and Seed Weight
  getPlotSeedPalletAndSeedWeightData(): string {
    return this.baseUrl + this.getPlotSeedPalletAndSeedWeightDataUrl;
  }
  // Check existing order
  checkPlotSeedExistingOrder(): string {
    return this.baseUrl + this.checkPlotSeedExistingOrderUrl;
  }
  // Get Web Order Numbers for Release Order
  getPlotSeedOrderNumbersData(): string {
    return this.baseUrl + this.getPlotSeedOrderNumbersDataUrl;
  }
  // Get Plot Seed Orders for Release
  getPlotSeedOrderItemDetailData(): string {
    return this.baseUrl + this.getPlotSeedOrderItemDetailDataUrl;
  }
  // Get Plot Seed Orders for Release
  getPlotSeedOrderSalesManagerData(): string {
    return this.baseUrl + this.getPlotSeedOrderSalesManagerDataUrl;
  }
  // Get Plot Seed Release Breakdown Lots
  getPlotSeedItemAvailabilityByLotData(): string {
    return this.baseUrl + this.getPlotSeedItemAvailabilityByLotDataUrl;
  }
  // Get Plot Seed Release Order Data
  getPlotSeedReleaseOrderData(): string {
    return this.baseUrl + this.getPlotSeedReleaseOrderDataUrl;
  }
  // Get Plot Seed Release JDE Sync Data
  getPlotSeedReleaseJDESyncData(): string {
    return this.baseUrl + this.getPlotSeedReleaseJDESyncDataUrl;
  }
  // Get Plot Seed Release Order Error Data
  getPlotSeedReleaseOrderErrorData(): string {
    return this.baseUrl + this.getPlotSeedReleaseOrderErrorDataUrl;
  }
  // Export Plot Seed Release Order Data
  exportPlotSeedReviewReleaseData(): string {
    return this.baseUrl + this.exportPlotSeedReviewReleaseDataUrl;
  }
  // Check access for Proving Ground Seed Order
  checkCreateAccessForPgs(): string {
    return this.baseUrl + this.checkCreateAccessForPgsUrl;
  }
  // Get Seed Header Data for Create Order of Proving Ground Seed Order
  getPgsCreateOrderHeaderData(): string {
    return this.baseUrl + this.getPgsCreateOrderHeaderDataUrl;
  }
  // Get Proving Ground Seed Order Deliver To data
  getPgsDeliverTo(): string {
    return this.baseUrl + this.getPgsDeliverToUrl;
  }
  // Get Proving Ground Seed Order Detail Data
  getPgsOrderDetailsData(): string {
    return this.baseUrl + this.getPgsOrderDetailDataUrl;
  }
  // Check existing order for Proving Ground Seed
  checkPgsExistingOrder(): string {
    return this.baseUrl + this.checkPgsExistingOrderUrl;
  }
  // Place Proving Ground Seed Order
  placePgsOrder(): string {
    return this.baseUrl + this.placePgsOrderUrl;
  }

  // Get Proving Ground Seed Order Summary
  getPgsOrderSummaryData(): string {
    return this.baseUrl + this.getPgsOrderSummaryUrl;
  }

  getPgsEditOrderDetail(): string {
    return this.baseUrl + this.getPgsEditOrderDetailUrl;
  }

  // Get COI Landing Grid Data
  public getCoiLandingGridDataUrl = `${this.baseUrl}api/COIFullfillment/get-landing-grid-data`;

  // Get COI Landing Export Data
  public getCoiLandingExportDataUrl = `${this.baseUrl}api/COIFullfillment/get-landing-export-data`;

  // Get all COI Location invoiced products for grid
  public getCoiLandingBannerMessageUrl = `${this.baseUrl}api/COIFullfillment/get-landing-banner-message`;

  // Get COI Draft order
  checkExistingCOIDraftOrderUrl = `${this.baseUrl}api/COIFullfillment/check-existing-coi-draft-order`;

  // Get COI Sold To account list
  getCoiSoldToFacilityDataUrl = `${this.baseUrl}api/COIFullfillment/get-coi-sold-to`;

  // Get COI sDeliver To accountlist
  getCoiDeliverToFacilityDataUrl = `${this.baseUrl}api/COIFullfillment/get-coi-deliver-to-facility`;

  // Get COI sDeliver To accountlist
  getCoiShipToAccountDataUrl = `${this.baseUrl}api/COIFullfillment/get-coi-ship-to-account`;

  getCoiInstructionTypeDataUrl = `${this.baseUrl}api/COIFullfillment/get-coi-instruction-type-data`;

  getCoiItemNumbersDataUrl = `${this.baseUrl}api/COIFullfillment/get-coi-item-numbers`;

  // Get Coi edit order details
  private getCoiEditOrderDetailDataUrl = 'api/COIFullfillment/get-cpp-coi-edit-order-data';

  public getCoiNewRequestEmail = `${this.baseUrl}api/COIFullfillment/send-coi-new-request-email`;

  public deleteCoiDraftRequest = `${this.baseUrl}api/COIFullfillment/delete-draft-request-detail`;

  // Place coi order data
  private placeCoiOrderdataUrl = 'api/COIFullfillment/place-coi-order';
  // `${this.baseUrl}api/COIFullfillment/place-coi-order`;

  // Save Coi order data
  private saveCoiOrderdataUrl = 'api/COIFullfillment/save-coi-order';
  // `${this.baseUrl}api/COIFullfillment/save-coi-order`;

  // send confirmation email
  sendCoiNewRequestEmail(): string {
    return this.baseUrl + this.getCoiNewRequestEmail;
  }

  // delete coi draft request
  deleteDraftRequestDetail(): string {
    return this.baseUrl + this.deleteCoiDraftRequest;
  }

  // Stock Transfer

  // Get Account details for Account dropdown
  getSOTAccountListUrl(): string {
    return this.baseUrl + this.sotAccountListUrl;
  }
  // Get Account details for Account dropdown
  getSOTDeliverToUrl(): string {
    return this.baseUrl + this.sotDeliverToUrl;
  }
  // Get Landing page data list
  getSOTGridListUrl(): string {
    return this.baseUrl + this.sotGridListUrl;
  }

  // Get Account details for Account dropdown
  getSOTToAccountListUrl(): string {
    return this.baseUrl + this.sotToAccountListUrl;
  }

  // Get Account details for Account dropdown
  getSOTEditOrderDetailURLUrl(): string {
    return this.baseUrl + this.sotEditOrderDetailURL;
  }

  // Get sot request history detail url
  getSotRequestHistoryUrl(): string {
    return this.baseUrl + this.sotRequestHistoryUrl;
  }

  // Get sot configuration list url
  getSotConfigurationListUrl(): string {
    return this.baseUrl + this.sotConfigurationListUrl;
  }

  // Get sot transfer distance url
  getSotTransferDistanceUrl(): string {
    return this.baseUrl + this.sotTransferDistanceUrl;
  }

  deleteSOTDraftRequestDetail(): string {
    return this.baseUrl + this.sotDeleteDraftURL;
  }

  // Get Landing page data list
  getSOTExprotListUrl(): string {
    return this.baseUrl + this.sotGridExportUrl;
  }

  // Get cancelOrderRequest for sot url
  cancelSotOrderRequestDetail(): string {
    return this.baseUrl + this.sotOrderCancelUrl;
  }

  // Get Pdf Order Data
  getSOTPdfOrderDetailURLUrl(): string {
    return this.baseUrl + this.sotPdfOrderDetailURL;
  }

  // Get Pdf Order Data
  checkSotOTIOrdersForPO(): string {
    return this.baseUrl + this.checkSotOTIOrdersForPOUrl;
  }

  // send Seed Replant confirmation email
  sendSotRequestEmail(): string {
    return this.baseUrl + this.sendSOTRequestEmail;
  }

  // Delivery Instruction

  getDeliveryInstructionList(): string {
    return this.baseUrl + this.getDeliveryInstructionListUrl;
  }
  getDeliveryInstructionAccountsList(): string {
    return this.baseUrl + this.getDeliveryInstructionAccountsListUrl;
  }

  saveDeliveryInstructionList(): string {
    return this.baseUrl + this.saveDeliveryInstructionAccountsListUrl;
  }

  getDeliveryInstructionEditData(): string {
    return this.baseUrl + this.getDeliveryInstructionEditDataUrl;
  }
  deleteDeliveryInstruction(): string {
    return this.baseUrl + this.deleteDeliveryInstructionUrl;
  }

  // ------Subscription Management---------------

  // Get Landing page data list
  getSubscriptionMgmtGridListUrl(): string {
    return this.baseUrl + this.subscriptionMgmtGridListUrl;
  }

  // Save Subscription list
  saveSubscriptionListUrl(): string {
    return this.baseUrl + this.saveSubscriptionsUrl;
  }
  // Check Manage subscription tab availability
  checkManageSubAvailibility(): string {
    return this.baseUrl + this.showManageSub;
  }

  // Get data For Export
  getSubscriptionDataForExport(): string {
    return this.baseUrl + this.exportData;
  }

  // Get Subscriptions list
  getSubscriptionsListUrl(): string {
    return this.baseUrl + this.subscriptionsListUrl;
  }

  // Get Subscriptions for single account
  getSubscriptionForAccountUrl(): string {
    return this.baseUrl + this.subscriptionForAccountUrl;
  }

  // Get Rolelist For ddl filter
  getRoleListUrl(): string {
    return this.baseUrl + this.subscriptionRoleddlUrl;
  }

  getSubscriptionTypeListUrl(): string {
    return this.baseUrl + this.SubscriptionTypeListddlUrl;
  }

  // CPP Delivery Instruction
  getCPPDeliveryInstructions(): string {
    return this.baseUrl + this.getCPPDeliveryInstructionUrl;
  }

  getcppUser(): string {
    return this.baseUrl + this.getCPPUserUrl;
  }

  getCPPDeliveryInstructionEditData(): string {
    return this.baseUrl + this.getCPPDeliveryInstructionAddEditDataUrl;
  }
  getCPPDeliveryInstructionDeleteData(): string {
    return this.baseUrl + this.getCPPDeliveryInstructionDeleteDataUrl;
  }

  getCPPUserListEditData(): string {
    return this.baseUrl + this.getCPPUserListAddEditDataUrl;
  }
  getCPPUserListDeleteData(): string {
    return this.baseUrl + this.getCPPUserListDeleteDataUrl;
  }
  getCPPUserListAccountsList(): string {
    return this.baseUrl + this.getCPPUserListAccountsListUrl;
  }

  checkSurveyMessageEligibiltyData(): string {
    return this.baseUrl + this.checkSurveyMessageEligibiltyDataUrl;
  }

  saveSurveyPreferenceData(): string {
    return this.baseUrl + this.saveSurveyPreferenceDataUrl;
  }

  checkOTISurveyMessageEligibiltyData(): string {
    return this.baseUrl + this.checkOTISurveyMessageEligibiltyDataUrl;
  }

  // Grower Programs

  // Get Landing page data list
  getGPLandingGridData(): string {
    return this.baseUrl + this.getGrowerProgramLandingDataUrl;
  }

  // Get Seed Des Landing page data list
  getGPSeedDesData(): string {
    return this.baseUrl + this.getGrowerProgramSeedDesDataUrl;
  }

  // Export Seed Des Landing page data list
  getGPExportSeedDesData(): string {
    return this.baseUrl + this.getExportSeedDesDataUrl;
  }

  getAiResponseUrl(): string {
    return this.baseUrl + this.aiResposeUrl;
  }

  getUserSlectedAccountForChatUrl(): string {
    return this.baseUrl + this.userSelectedAccountForChatUrl;
  }

  getaiCPPProductSearchUrl(): string {
    return this.baseUrl + this.aiCppProductSeachUrl;
  }

  getaiReviewCppOrderUrl(): string {
    return this.baseUrl + this.aiReviewCppOrderUrl;
  }
  getaiPlaceCppOrderUrl(): string {
    return this.baseUrl + this.aiPlaceCppOrderUrl;
  }
  getsfmessageUrl(): string {
    return this.baseUrl + this.sfmessageUrl;
  }
  getairesetUrl(): string {
    return this.baseUrl + this.aiResetUrl;
  }
  getaimenuconfigUrl(): string {
    return this.baseUrl + this.aiMenuUrl;
  }
  gettrackingemailUrl(): string {
    return this.baseUrl + this.aitrackingemailUrl;
  }
  getSFChatUrl(): string {
    return this.baseUrl + this.sfchatUrl;
  }
  getrecentChatUrl(): string {
    return this.baseUrl + this.recentChatUrl;
  }
  getcloseConversationUrl(): string {
    return this.baseUrl + this.closeConversationUrl;
  }
  getsfTranscriptUrl(): string {
    return this.baseUrl + this.sendsfTranscriptUrl;
  } 
  // ----------------------------------------Seed Replant
  // Get Seed Replant Landing Banner Message
  public getSeedReplantLandingBannerMessageUrl = `${this.baseUrl}api/SeedReplant/get-landing-banner-message`;

  // Get Seed Replant Landing Grid Data
  public getSeedReplantLandingGridDataUrl = `${this.baseUrl}api/SeedReplant/get-landing-grid-data`;

  // Get Seed Replant Landing Export Data
  public getSeedReplantLandingExportDataUrl = `${this.baseUrl}api/SeedReplant/get-landing-export-data`;

  // Delete Seed Replant Draft
  public deleteSeedReplantDraftRequest = `${this.baseUrl}api/SeedReplant/delete-draft-request-detail`;

  public sendSeedReplantRequestEmail = `${this.baseUrl}api/SeedReplant/send-seed-replant-new-request-email`;

  private relSeedReplantGrowerSearchUrl = 'api/SeedReplant/grower-list-by-account';

  // -------------------------------------------------------------------------------------------------

  // Get Order Summary details.
  public getCOIOrderSummaryDetailsUrl = `${this.baseUrl}api/COIFullfillment/get-order-summary-detail`;

  private getCoiAccountSDMDataUrl = 'api/COIFullfillment/AccountSDMData';

  private getCoiItemsSDMDataUrl = 'api/COIFullfillment/item-master-sdm-data';

  private getCoiDeliveryReasonChangeUrl = 'api/COIFullfillment/SDMReasonCodeSetupData';

  public coiCPPCheckOTIOrdersUrl = `${this.baseUrl}api/COIFullfillment/check-oti-orders`;

  // -----------------------------Crop Loss-----------------------------------------------------
  // Get Add Product list data
  public getInvoicedProductListUrl = `${this.baseUrl}api/CropLoss/get-items-list`;

  // Get Seed replant Landing Banner Message
  public getSeedCropLossLandingBannerMessageUrl = `${this.baseUrl}api/CropLoss/get-landing-banner-message`;

  // Get COI Landing Grid Data
  public getSeedCropLossLandingGridDataUrl = `${this.baseUrl}api/CropLoss/get-landing-grid-data`;

  // Get COI Landing Export Data
  public getSeedCropLossLandingExportDataUrl = `${this.baseUrl}api/CropLoss/get-landing-export-data`;

  // Get Ship To account list
  public getSeedCropLossShipToAccountDataUrl = `${this.baseUrl}api/CropLoss/get-ship-to-account`;

  // Get Sold To account list
  public getSeedCropLossSoldToFacilityDataUrl = `${this.baseUrl}api/CropLoss/get-sold-to-accounts`;

  // Get Credit To account list
  public getSeedCropLossCreditToAccountDataUrl = `${this.baseUrl}api/CropLoss/get-credit-to-accounts`;

  // Get all lot master
  private getCropLossLotMasterItemsUrl = 'api/CropLoss/get-lot-master-list';

  // Get product line list
  public getCropLossProductLineListUrl = 'api/CropLoss/get-product-line-list';

  // Get Technology list
  public getCropLossTechnologyListUrl = 'api/CropLoss/get-technology-master-list';

  public getCropLossAccountUserRequestUrl = 'api/CropLoss/get-account-user-list';

  // save
  public saveCropLossUrl = `${this.baseUrl}api/CropLoss/save`;

  // Get Crop Loss edit details
  public getCropLossEditDetailDataUrl = `${this.baseUrl}api/CropLoss/get-edit-details`;

  public deleteCropLossDraftRequest = `${this.baseUrl}api/CropLoss/delete-draft-request-detail`;

  // Submit Review Request
  public submitReviewRequestCropLossUrl = `${this.baseUrl}api/CropLoss/submit-review-request`;

  // Approve Review Request
  public approveReviewRequestCropLossUrl = `${this.baseUrl}api/CropLoss/approve-review-request`;

  // get Effective Config Data
  public getEffectiveConfigDataCropLossUrl = `${this.baseUrl}api/CropLoss/get-effective-config-data`;

  // New Request Confirmation Email
  public getCropLossNewRequestEmail = `${this.baseUrl}api/CropLoss/send-cropLoss-new-request-email`;

  // Get items license
  public getItemsLicenseCropLossData = `${this.baseUrl}api/CropLoss/get-items-license`;

  public getCropLossGrowerSearchUrl = 'api/CropLoss/grower-list-by-account';

  public getTreatmentDataCropLossUrl = 'api/CropLoss/get-entry-treatment-list';

  // Get Admin Config Message
  public getCropLossAdminConfigMessageListUrl = 'api/CropLoss/get-admin-config-list';

  // -----------------------------Seed Replant---------------------------------------------------
  // Get all lot master
  private getSeedReplantLotMasterItemsUrl = 'api/SeedReplant/get-lot-master-list';

  // Get product line list
  public getSeedReplantProductLineListUrl = 'api/SeedReplant/get-product-line-list';

  // Get Technology list
  public getSeedReplantTechnologyListUrl = 'api/SeedReplant/get-technology-master-list';

  // Get Add Original Product list data
  public getOriginalInvoicedProductListUrl = `${this.baseUrl}api/SeedReplant/get-items-list`;

  // Get Add Replant Product list data
  public getReplantProductListUrl = `${this.baseUrl}api/SeedReplant/get-replant-items-list`;

  // Get Ship To account list
  public getSeedReplantShipToAccountDataUrl = `${this.baseUrl}api/SeedReplant/get-ship-to-account`;

  // Get Sold To account list
  public getSeedReplantSoldToFacilityDataUrl = `${this.baseUrl}api/SeedReplant/get-sold-to-accounts`;

  // Get Credit To account list
  public getSeedReplantCreditToAccountDataUrl = `${this.baseUrl}api/SeedReplant/get-credit-to-accounts`;

  public getSeedReplantAccountUserRequestUrl = 'api/SeedReplant/get-account-user-list';

  // save
  public saveSeedReplantUrl = `${this.baseUrl}api/SeedReplant/save`;

  // Get Crop Loss edit details
  public getSeedReplantEditDetailDataUrl = `${this.baseUrl}api/SeedReplant/get-edit-details`;

  // Submit Review Request
  public submitReviewRequestSeedReplantUrl = `${this.baseUrl}api/SeedReplant/submit-review-request`;

  // Approve Review Request
  public approveReviewRequestSeedReplantUrl = `${this.baseUrl}api/SeedReplant/approve-review-request`;

  // Approve Review Request with Pricing (for auto-approval)
  public approveReviewRequestWithPricingSeedReplantUrl = `${this.baseUrl}api/SeedReplant/approve-review-request-with-pricing`;

  // get Effective Config Data
  public getEffectiveConfigDataSeedReplantUrl = `${this.baseUrl}api/SeedReplant/get-effective-config-data`;

  // Get items license
  public getItemsLicenseSeedReplantData = `${this.baseUrl}api/SeedReplant/get-items-license`;
  // -----------------------------SOT Stock Transfer---------------------------------------------------
  // Get Account List return request
  private sotAccountListUrl = 'api/SOTStockTransfer/from-account-list';

  private sotDeliverToUrl = 'api/SOTStockTransfer/get-deliver-to-location';

  private sotGridListUrl = 'api/SOTStockTransfer/get-landing-grid-data';

  private sotToAccountListUrl = 'api/SOTStockTransfer/to-account-list';

  private sotEditOrderDetailURL = 'api/SOTStockTransfer/get-sot-edit-order-data';
  private sotDeleteDraftURL = 'api/SOTStockTransfer/delete-draft-request-detail';
  private sotRequestHistoryUrl = 'api/SOTStockTransfer/get-request-history';
  private sotConfigurationListUrl = 'api/SOTStockTransfer/get-sot-configuration-list';
  private sotTransferDistanceUrl = 'api/SOTStockTransfer/get-transfer-distance';

  public getTreatmentDataSeedReplantUrl = 'api/SeedReplant/get-entry-treatment-list';

  // Get Admin Config Message
  public getSeedReplantAdminConfigMessageListUrl = 'api/SeedReplant/get-admin-config-list';

  public exportToExcelDataUrl = 'api/SeedReplant/export-to-excel';

  public soybeanCheckAutoApproveURL = 'api/SeedReturn/check-auto-approve';
  public submitForCreditAutoApproveURL = 'api/SeedReturn/submit-for-credit-auto';


  // Get all stock transfer products for add product grid
  public getSOTProductItemsUrl = `${this.baseUrl}api/SOTStockTransfer/get-items-list`;

  public sotSaveOrderUrl = `${this.baseUrl}api/SOTStockTransfer/save-order`;
  public sotUpdateRequestStatusUrl = `${this.baseUrl}api/SOTStockTransfer/update-request-status`;
  private sotGridExportUrl = 'api/SOTStockTransfer/get-landing-export-data';

  private sotOrderCancelUrl = 'api/SOTStockTransfer/cancel-order-request-detail';

  private sotPdfOrderDetailURL = 'api/SOTStockTransfer/get-sot-pdf-order-data';

  // Check OTI Orders
  private checkSotOTIOrdersForPOUrl = 'api/SOTStockTransfer/check-oti-orders';
  // -----------------------------Container Returns---------------------------------------------------

  // Get Add Product list data
  public getContainerReturnInvoicedProductListUrl = `${this.baseUrl}api/ContainerReturns/get-items-list`;

  // Get Banner Message
  public containerReturnsBannerMessageUrl = `${this.baseUrl}api/ContainerReturns/get-banner-message`;

  // Get Container orders list for export
  public getContainerReturnsRequesReporttUrl = `${this.baseUrl}api/ContainerReturns/get-return-request-report`;

  // Delete container return
  public deleteContainerReturnRequestUrl = `${this.baseUrl}api/ContainerReturns/delete-return-request`;

  // Check OTI Orders
  public containerReturnsCheckOTIOrdersUrl = `${this.baseUrl}api/ContainerReturns/check-oti-orders`;

  public accountUserContainerReturnRequestUrl = `${this.baseUrl}api/ContainerReturns/get-account-user-list`;

  public sendSOTRequestEmail = `${this.baseUrl}api/SOTStockTransfer/send-request-email`;

  //------------------------------------------- SRA Cost Sheet ---------------------------------------------

  // Get retail filters data list
  public sraCostSheetFilterDataUrl = `${this.baseUrl}api/SRACostSheet/get-sra-filters-data`;

  // Get SRA Grids data
  public sraCostSheetLandigGridDataUrl = `${this.baseUrl}api/SRACostSheet/get-grids-data`;

  // Get Since Date for Sra Url
  public getSinceDateDataUrl = `${this.baseUrl}api/SRACostSheet/get-since-date`;

  // Get SRA Grids data Export
  public sraCostSheetLandigGridDataExportCostSheetTabExportUrl = `${this.baseUrl}api/SRACostSheet/get-grid-tab-data-export`;

  // Get excel template
  public sraCostSheetDownloadExcelTemplateUrl = `${this.baseUrl}api/SRACostSheet/download-excel-template`;

  // Get SRA Grids Simulation data
  public sraCostSheetSimulationGridDataUrl = `${this.baseUrl}api/SRACostSheet/get-simulation-grids-data`;

  // Get Glossary Data
  public getCppSraCostSheetGlossaryDataUrl = `${this.baseUrl}api/SRACostSheet/get-glossary-data`;

  // Save Temp Rates
  public saveTempRatesDataUrl = `${this.baseUrl}api/SRACostSheet/save-temp-rates`;

  // Save SRA Grids Simulation Toggle Settings
  public saveToggleSettingsDataUrl = `${this.baseUrl}api/SRACostSheet/save-toggle-preference`;

  // Get SRA Grids Simulation Toggle Settings
  public getToggleSettingsDataUrl = `${this.baseUrl}api/SRACostSheet/get-toggle-preference/{{tabName}}`;

  // Get Cpp order detail data
  setCostFavorite(): string {
    return this.baseUrl + this.setCostFavoriteUrl;
  }

  // ------------------------------------------Subscription Managment --------------------------------------------

  private subscriptionMgmtGridListUrl = 'api/SubscriptionManagement/get-my-subscription';

  private saveSubscriptionsUrl = 'api/SubscriptionManagement/save-subscriptions';

  private showManageSub = 'api/SubscriptionManagement/show-manage-subscription';

  private exportData = 'api/SubscriptionManagement/export-subscriptions';

  private subscriptionsListUrl = 'api/SubscriptionManagement/get-globally-subscriptions';

  private subscriptionForAccountUrl = 'api/SubscriptionManagement/get-subscriptions-account';

  private subscriptionRoleddlUrl = 'api/SubscriptionManagement/role-list';
  private SubscriptionTypeListddlUrl = 'api/SubscriptionManagement/subscription-type-list';

  // Delivery Instructions
  public getDeliveryInstructionListUrl = 'api/DeliveryInstructions/delivery-instructions-list';
  public getDeliveryInstructionAccountsListUrl = 'api/DeliveryInstructions/get-delivery-instructions-accounts';

  public saveDeliveryInstructionAccountsListUrl = 'api/DeliveryInstructions/add-edit-delivery-instructions';
  public getDeliveryInstructionEditDataUrl = 'api/DeliveryInstructions/get-delivery-instructions-edit';
  public deleteDeliveryInstructionUrl = 'api/DeliveryInstructions/delete-delivery-instructions';
  public getCPPUserUrl = 'api/CPPUserList/get-cpp-user';

  // ------------------------------------------CPP DELIVERY INSTRUCTION------------------------------------------------
  public getCPPDeliveryInstructionUrl = 'api/CPPDeliveryInstruction/get-delivery-instructions';

  public getCPPDeliveryInstructionAddEditDataUrl = 'api/CPPDeliveryInstruction/add-edit-delivery-instructions';

  public getCPPDeliveryInstructionDeleteDataUrl = 'api/CPPDeliveryInstruction/delete-delivery-instructions';

  //-------------------------------------------Grower Program----------------------------------------------
  public getGrowerProgramMasterDataUrl = 'api/GrowerProgramDashboard/get-gp-master-data';
  public getGrowerProgramLandingDataUrl = 'api/GrowerProgramDashboard/get-gp-landing-data';
  public getGrowerProgramSeedDesDataUrl = 'api/GrowerProgramDashboard/get-gp-seed-discretionary-data';
  public getExportSeedDesDataUrl = 'api/GrowerProgramDashboard/gp-export-seed-discretionary';
  public saveSpendDetailsDataUrl = 'api/GrowerProgramDashboard/save-grower-program-list';
  public deleteSpendDetailsDataUrl = 'api/GrowerProgramDashboard/delete-grower-program-list';
  public importSpendDetailsDataUrl = 'api/GrowerProgramDashboard/import-excel';
  public getAutoSaveConfigUrl = 'api/Common/get-auto-save-configuration';
  public getDownloadtemplateUrl = 'api/GrowerProgramDashboard/download-upload-template';
  public saveGPSpendCommentDetailsDataUrl = 'api/GrowerProgramDashboard/save-gp-spend-comment-data';
  public getGPSpendCommentDetailsDataUrl = 'api/GrowerProgramDashboard/get-gp-spend-comment-data';
  public saveGPSubscriptionStatusUrl = 'api/GrowerProgramDashboard/save-gp-subscription-status';
  public approveRejectSubmitSpendDetailUrl = 'api/GrowerProgramDashboard/gp-submit-approve-reject';
  public updateGrowerProgramStatusVoidUrl = 'api/GrowerProgramDashboard/update-spend-status-void';
  public updateGrowerProgramManualExtractionUrl = 'api/GrowerProgramDashboard/update-manual-extraction-status';

  // Season Banner Message

  public seasonBannerURL = 'api/Common/season-banner';

  //----CPP Marketing Program----

  public getMarketingProgramSummaryDataUrl = 'api/CPPMarketingProgram/get-marketing-program-data';
  public toggleFavoriteItemUrl = 'api/CPPMarketingProgram/toggle-favorite-item';
  public toggleFavoriteManufacturerUrl = 'api/CPPMarketingProgram/toggle-favorite-manufacturer';
  public getMarketingProgramTileDataUrl = 'api/CPPMarketingProgram/get-marketing-program-tile-data';
  public getFilterMasterDataUrl = 'api/CPPMarketingProgram/get-filter-master-data';
  public downloadProgramFileDataUrl = 'api/CPPMarketingProgram/download-program-pdf';


  //--------------------CPP SRO Orders-------------------

  public getSROOrdersListURL = 'api/CPPSROOrder/get-cpp-sro-orders';
  // Get SRA Ship To Account data
  private getSraShipToFacilityDataUrl = 'api/CPPSROOrder/get-ship-to-facility';
  // Get SRA Place Order
  private getSraOrderRequestUrl = 'api/CPPSROOrder/save-order-request';
  // Get SRA SDM
  private getSroItemsSDMDataUrl = 'api/CPPSROOrder/item-master-sdm-data';

  private getRequestDetailsForSelectedRecordsUrl = 'api/CPPSROOrder/get-request-details-for-selected';
  private updateRequestDateUrl = 'api/CPPSROOrder/update-requested-delivery-date';
  //-------------------CPP User List-------------------
  public getCPPUserListAddEditDataUrl = 'api/CPPUserList/add-edit-user-list';

  public getCPPUserListDeleteDataUrl = 'api/CPPUserList/delete-user-list';

  public getCPPUserListAccountsListUrl = 'api/CPPUserList/get-user-list-accounts';

  //----Plot Seed Order---
  public exportToExcelPlotSeedDataUrl = 'api/PlotSeed/export-to-excel';

  //--------------------SEED Associate Crop-------------------
  // Get Seed Crop Associate Locations
  public getSeedCropAssociateLocationsUrl = 'api/SeedCropAssociate/get-locations';
  // Get Seed Crop Associate Ship To Account data
  private getSeedCropAssociateAccountUrl = 'api/SeedCropAssociate/account-list';
  // Get Seed Crop Associate Deliver To data
  private getSeedCropAssociateDeliverToUrl = 'api/SeedCropAssociate/get-deliverTo';
  // Get Seed Crop Associate Details Data
  private getSeedCropDetailsDataUrl = 'api/SeedCropAssociate/get-deatail-list';
  // Seed Crop Place Order
  private getSeedCropPlaceRequestUrl = 'api/SeedCropAssociate/place-request';
  // Get Seed Crop Associate Landing Data
  private GetSeedCropAssociatesLandingDataUrl = 'api/SeedCropAssociate/landing-order';
  // Get Seed Crop Associate Order Summary
  private GetSeedCropAssociatesOrderSummaryUrl = 'api/SeedCropAssociate/get-order-summary';
  // Get Seed Crop Associate Order Report URL
  private getSeedCropAssociateReportUrl = 'api/SeedCropAssociate/generate-report';

  // post base64 pdf format
  private getAssociatePdfUrl = 'api/SeedCropAssociate/get-pdf-file';

  //Reconcile Orders

  //Get Reconcile order Data
  private GetSeedCropAssociatesReconciliationLandingDataUrl = 'api/SeedCropAssociate/landing-reconciliation-order';

  // Get Seed Crop Associate Details Data
  private getReconcileVariety = 'api/SeedCropAssociate/get-reconcile-variety';


  // Get Seed Crop Associate Details Data
  private addUpdateReconcileOrder = 'api/SeedCropAssociate/update-reconcile-order';

  // post base64 pdf format
  private getMobileVersionPdfUrl = 'api/SeedCropAssociate/FileShareMobilePDFURL';

  // Get Inventory Location Landing Grid Data 
  private getInventoryLandingDataUrl = 'api/SeedCropAssociate/inventory-landing-data';

  // Get Inventory Location Master Data 
  private getInventoryMasterDataUrl = 'api/SeedCropAssociate/get-inventory-master-data';

  // Get Inventory Location List 
  private getInventoryLocationListUrl = 'api/SeedCropAssociate/inventory-location-list';

    // Get Seed Crop Associate Details Data
  private addUpdateInventoryOrder = 'api/SeedCropAssociate/update-inventory-order';

  //--------------------SEED PLOT SEED-------------------
  private checkCreateAccessForPlotSeedUrl = 'api/PlotSeed/check-create-access';
  // Get Plot Seed Product Lines
  private getPlotSeedProductLinesUrl = 'api/PlotSeed/get-productLines';

  // get Plot Seed maturity
  private getPlotSeedMaturitydataUrl = 'api/PlotSeed/get-maturityOptions';

  // get Plot Seed Status
  private getPlotSeedStatusListUrl = 'api/PlotSeed/get-status-list';
  // Proving Ground Seed order inquiry
  private getPgsOrderProductLinesUrl = 'api/PgsOrder/product-lines';
  private getPgsOrderLandingDataUrl = 'api/PgsOrder/landing-order';
  private getPgsPackDetailsUrl = 'api/PgsOrder/pack-details';
  private getPgsOrderExportUrl = 'api/PgsOrder/export-to-excel';
  //Get Plot Seed Landing Data
  private getPlotSeedLandingDataUrl = 'api/PlotSeed/landing-order';
  //Get Plot Seed Detail Data
  private getPlotSeedDetailDataUrl = 'api/PlotSeed/detail-data';

  // Get Plot Seed Order Summary
  private getPlotSeedOrderSummaryUrl = 'api/PlotSeed/get-order-summary';

  //Get Header Data for Create Order
  private getPlotSeedCreateOrderHeaderDataUrl = 'api/PlotSeed/get-create-order-header-data';

  //Get Header Data for setup
  private getPlotSeedOrderDateSetupDataUrl = 'api/PlotSeed/plot-seed-date-setup';

  //Get Ship To and ASC Accounts
  private getPlotSeedShipToAscAccountDataUrl = 'api/PlotSeed/get-shipto-asc-accounts';

  //Get Plot Seed Release Landing Data
  private getPlotSeedReleaseDataUrl = 'api/PlotSeedRelease/plot-release-order-items';

  // Get Deliver To data
  private getPlotSeedDeliverToUrl = 'api/PlotSeed/get-deliverTo';
  // Place Plot Seed Order
  private placePlotSeedOrderUrl = 'api/PlotSeed/place-order';
  // post base64 pdf format
  private getPlotSeedPdfUrl = 'api/PlotSeed/get-pdf-file';
  // post base64 pdf format
  private getPlotSeedMobileVersionPdfUrl = 'api/PlotSeed/FileShareMobilePDFURL';
  //Get Header Data for Release Order
  private getPlotSeedReleaseOrderHeaderDataUrl = 'api/PlotSeedRelease/get-release-order-header-data';
  //Get Ship To and ASC Accounts
  private getPlotSeedOrderShipToDataaUrl = 'api/PlotSeedRelease/get-shipto-accounts';
  // check existing order
  private checkPlotSeedExistingOrderUrl = 'api/PlotSeed/check-existing-order';
  //Get Web Order Numbers for Release Order
  private getPlotSeedOrderNumbersDataUrl = 'api/PlotSeedRelease/get-order-numbers';
  //Get Plot Seed Orders for Release
  private getPlotSeedOrderItemDetailDataUrl = 'api/PlotSeedRelease/get-order-items-detail';
  //Get Plot Seed Orders for Release
  private getPlotSeedOrderSalesManagerDataUrl = 'api/PlotSeedRelease/get-sales-manager-accounts';
  //Place ERP Order
  private placePlotSeedJDEOrderUrl = 'api/PlotSeedRelease/place-erp-order';
  //Place ERP Order
  private getPlotSeedPalletAndSeedWeightDataUrl = 'api/PlotSeedRelease/get-pallet-and-seed-weight';
  // Get plot seed item availability by lot url
  private getPlotSeedItemAvailabilityByLotDataUrl = 'api/PlotSeedRelease/get-items-availability-by-lots';
  // Get plot seed release order data url
  private getPlotSeedReleaseOrderDataUrl = 'api/PlotSeedRelease/get-review-release-data';
  // Get plot seed release jde sync data
  private getPlotSeedReleaseJDESyncDataUrl = 'api/PlotSeedRelease/get-jde-release-sync-data';
  // Get plot seed release order error data url
  private getPlotSeedReleaseOrderErrorDataUrl = 'api/PlotSeedRelease/get-review-release-error-data';
  // Export plot seed release order data url
  private exportPlotSeedReviewReleaseDataUrl = 'api/PlotSeedRelease/export-review-release-data';
  // Check create access for Proving Ground Seed Order
  private checkCreateAccessForPgsUrl = 'api/PgsOrder/check-create-access';
  // Get Header Data for Create Order of Proving Ground Seed Order
  private getPgsCreateOrderHeaderDataUrl = 'api/PgsOrder/get-create-order-header-data';
  // Get Deliver To data for Proving Ground Seed Order
  private getPgsDeliverToUrl = 'api/PgsOrder/get-deliverTo';
  // Get Proving Ground Seed Order Detail Data
  private getPgsOrderDetailDataUrl = 'api/PgsOrder/get-detail-data';
  // Place Proving Ground Seed Order
  private placePgsOrderUrl = 'api/PgsOrder/place-order';
  // Check existing Proving Ground Seed Order
  private checkPgsExistingOrderUrl = 'api/PgsOrder/check-existing-order';
  // Get Proving Ground Seed Order summary data
  private getPgsOrderSummaryUrl = 'api/PgsOrder/get-edit-order-detail';
  private getPgsEditOrderDetailUrl = 'api/PgsOrder/get-edit-order-detail';
}
